import React, { Fragment, useState, useEffect, useRef, useMemo } from "react";
import { 
  FaCompress, FaExpandArrowsAlt, FaArrowsAlt, FaCrop, FaSyncAlt, FaMagic, FaImage, FaFileImage, FaFilm, FaImages, FaPalette, FaPaintBrush, FaPaintRoller, FaAdjust, FaTint, FaFill, FaBorderAll, FaThLarge, FaBrush, FaMousePointer, FaEye, FaEyeDropper, FaWind, FaCodeBranch, FaTags, FaRobot, FaBookOpen, FaSearchPlus, FaSitemap, FaRandom, FaEnvelopeOpenText, FaLinkedinIn, FaTextHeight, FaSortNumericUp, FaFont, FaHashtag, FaInstagram, FaUserEdit, FaCalculator, FaTiktok, FaVideo, FaTwitter, FaStar, FaAlignLeft, FaQrcode, FaCalendarAlt, FaPercentage, FaBalanceScale, FaCode, FaExchangeAlt, FaFingerprint, FaLock, FaSearch, FaColumns, FaMoneyBillWave, FaChartLine, FaBox, FaWarehouse, FaChartPie, FaBalanceScaleRight, FaHandHoldingUsd, FaPiggyBank, FaRocket, FaTicketAlt, FaCheckDouble, FaAward, FaLink, FaStarHalfAlt, FaCubes, FaKeyboard, FaBullseye, FaRupeeSign, FaTruck, FaBolt, FaAd, FaShoppingBag, FaCoins, FaClipboardCheck, FaShieldAlt, FaTrophy, FaShieldVirus, FaUndoAlt, FaBullhorn, FaLayerGroup, FaShippingFast, FaUserSecret, FaPercent, FaMoneyCheckAlt, FaTshirt, FaPumpSoap, FaGem, FaMotorcycle, FaStopwatch, FaTools, FaPlug, FaCog, FaDatabase, FaGlobeAmericas, FaStore, FaFileInvoiceDollar, FaChartArea, FaNewspaper, FaBook, FaPencilAlt, FaUsers, FaGraduationCap, FaFileSignature, FaDesktop, FaDraftingCompass, FaGlobe, FaCompass,
  FaFacebook, FaLinkedin, FaYoutube, FaWhatsapp, FaHome, FaPhoneAlt, FaBars, FaTimes, FaChevronDown, FaChevronUp, FaBriefcase, FaEnvelope, FaGoogle, FaAmazon, FaShopify,
  FaAws, FaGithub
} from "react-icons/fa";
import { SiNvidia } from "react-icons/si";
import { motion, AnimatePresence } from "framer-motion";
import "./HeaderStyle.css";
import { Link, graphql, useStaticQuery } from "gatsby";
import { getPublicRouteItems } from "../data/siteRouteMenu";
import { megaMenuSections, servicesHighlights } from "../data/servicesData";
import { SERVICE_FAMILIES } from "../config/servicesNavigation";
import ServiceIcon from "./visuals/icons/ServiceIcons";
import { getLatestPlatformUpdates } from "../data/platformUpdates";
import bricon from "../../static/images/img/brand_icon/v.gif";
import {
  AppBar, Toolbar, Typography, Button, IconButton, Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Collapse, useTheme, useMediaQuery, Grid, Stack, Tooltip, Divider,
} from "@mui/material";
import { makeStyles } from "@mui/styles";



import ThemeToggle from "./ThemeToggle";
import SearchBar from "./SearchBar";
import WeatherClockWidget from "./WeatherClockWidget";
import SmartGuidePanel from "./SmartGuide/SmartGuidePanel";

// ==========================================
// STYLES (Modern Visme-Style & Glassmorphism)
// ==========================================
const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "var(--surface-1) !important",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05), 0 1px 0 var(--border-color)",
    position: "relative",
    zIndex: 1100,
  },
  topBar: {
    paddingTop: "0.4rem",
    paddingBottom: "0.4rem",
    backgroundColor: "transparent",
    width: "100%",
    minWidth: 0,
  },
  navRail: {
    width: "100%",
    backgroundColor: "var(--surface-1)",
    borderTop: "1px solid var(--border-color)",
  },
  toolbar: {
    padding: "0.5rem 0",
    minHeight: "75px",
    backgroundColor: "transparent",
    width: "100%",
    minWidth: 0,
  },
  logo: {
    height: "clamp(34px, 4vw, 46px)",
    width: "auto",
    maxWidth: "100%",
    cursor: "pointer",
    display: "block",
    borderRadius: "8px",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  headerBrand: {
    minWidth: 0,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },
  navSection: {
    display: "flex",
    alignItems: "center",
    gap: "0.35rem",
    marginLeft: 'auto',
    minWidth: 0,
    flexShrink: 1,
  },
  mobileControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginLeft: "auto",
    minWidth: 0,
    flexShrink: 1,
  },
  navButton: {
    color: "var(--text-secondary)",
    fontWeight: 600,
    padding: "6px 14px",
    borderRadius: "8px",
    textTransform: "none !important",
    fontSize: "0.84rem",
    whiteSpace: "nowrap !important",
    flexShrink: 0,
    letterSpacing: "0.01em",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "var(--surface-3)",
      color: "var(--text-primary)",
    },
  },
  dropdownButton: {
    color: "var(--text-secondary)",
    fontWeight: 600,
    padding: "6px 14px",
    borderRadius: "8px",
    textTransform: "none !important",
    fontSize: "0.84rem",
    whiteSpace: "nowrap !important",
    flexShrink: 0,
    letterSpacing: "0.01em",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "var(--surface-3)",
      color: "var(--text-primary)",
    },
    "&.header-dropdown-active": {
      backgroundColor: "var(--surface-3)",
      color: "var(--text-primary)",
      boxShadow: "inset 0 -2px 0 #2563eb",
    }
  },
  megaMenuWrapper: {
    position: "fixed",
    top: "105px",
    left: 0,
    right: 0,
    zIndex: 1300,
    padding: "0.5rem 1.5rem",
    maxWidth: "1600px",
    margin: "0 auto",
  },
  megaMenu: {
    position: "relative",
    borderRadius: "16px",
    boxShadow: "0 24px 48px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    background: "var(--surface-1)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    overflow: "hidden",
    display: "flex",
  },
  megaSidebar: {
    backgroundColor: "var(--surface-2)",
    padding: "1.25rem",
    width: "280px",
    flexShrink: 0,
    borderRight: "1px solid var(--border-color)",
  },
  megaBody: {
    padding: "1.25rem 1.5rem 5rem 1.5rem",
    flex: 1,
    overflowY: "auto",
    height: "auto",
    maxHeight: "calc(100vh - 120px)",
    overscrollBehavior: "contain",
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": { background: "#cbd5e1", borderRadius: "4px" },
  },
  featuredItem: {
    display: "flex",
    alignItems: "flex-start",
    padding: "8px 9px",
    borderRadius: "10px",
    textDecoration: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    marginBottom: "5px",
    backgroundColor: "transparent",
    position: "relative",
    "&:hover": {
      backgroundColor: "var(--surface-3)",
      boxShadow: "0 4px 12px var(--shadow-color, rgba(0,0,0,0.05))",
      transform: "translateY(-1px)",
      zIndex: 2,
      "& $featuredTitle": {
        color: "#2563eb",
      },
      "& $featuredDesc": {
        display: "block",
        WebkitLineClamp: "unset",
        WebkitBoxOrient: "unset",
        overflow: "visible",
        whiteSpace: "normal",
        textOverflow: "clip",
        color: "var(--text-primary)",
      },
    }
  },
  featuredIconBox: {
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1rem",
    marginRight: "10px",
    flexShrink: 0,
  },
  featuredTitle: {
    fontWeight: 700,
    fontSize: "0.78rem",
    color: "var(--text-primary)",
    marginBottom: "2px",
    lineHeight: 1.25,
    transition: "color 0.15s ease",
  },
  featuredDesc: {
    fontSize: "0.66rem",
    color: "var(--text-secondary)",
    lineHeight: 1.35,
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    transition: "color 0.18s ease",
    wordBreak: "break-word",
  },
  menuSection: {
    marginBottom: "0.85rem",
    width: "100%",
  },
  sectionHeader: {
    fontSize: "0.74rem",
    fontWeight: 800,
    color: "var(--text-primary)",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    marginBottom: "0.15rem",
  },
  sectionSubtitle: {
    fontSize: "0.65rem",
    color: "var(--text-secondary)",
    fontWeight: 500,
    lineHeight: 1.3,
    marginBottom: "0.35rem",
  },
  standardListItem: {
    display: "flex",
    alignItems: "flex-start",
    padding: "5px 7px",
    margin: "0 -2px 2px -2px",
    borderRadius: "7px",
    color: "var(--text-primary)",
    textDecoration: "none",
    transition: "all 0.18s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    "&:hover": {
      backgroundColor: "var(--surface-3)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
      transform: "translateX(2px)",
      zIndex: 2,
      "& $standardItemTitle": {
        color: "#2563eb",
      },
      "& $standardItemDesc": {
        display: "block",
        WebkitLineClamp: "unset",
        WebkitBoxOrient: "unset",
        overflow: "visible",
        whiteSpace: "normal",
        textOverflow: "clip",
        color: "var(--text-primary)",
      },
    }
  },
  standardItemIcon: {
    width: "22px",
    height: "22px",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "7px",
    marginTop: "1px",
    flexShrink: 0,
    fontSize: "0.78rem",
  },
  standardItemTitle: {
    fontSize: "0.74rem",
    fontWeight: 700,
    color: "var(--text-primary)",
    lineHeight: 1.25,
    transition: "color 0.15s ease",
  },
  standardItemDesc: {
    fontSize: "0.63rem",
    color: "var(--text-secondary)",
    lineHeight: 1.35,
    marginTop: "2px",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    transition: "color 0.18s ease",
    wordBreak: "break-word",
  },
  mobileDrawer: {
    width: "min(100vw, 380px)",
    maxWidth: "100%",
    backgroundColor: "var(--surface-1)",
  },
}));

// ==========================================
// STRICT HARDCODED NAVIGATION DATA
// ==========================================
const navigationData = {
  tools: {
    sections: [
      {
        title: "Social Media & Creator AI",
        subtitle: "Still puzzled what content to make? Steal viral scripts, hooks & captions",
        items: [
          { name: "Instagram intelligence", desc: "Still puzzled what content to make? 100+ proven creator playbooks, hooks & teardowns", path: "/instagram-insights", icon: "📸", color: "#EC4899", badge: "HOT" },
          { name: "Global Reel Inspiration", desc: "Need video ideas? Global industry Reel teardowns, formats & trends", path: "/tools/global-reel-inspiration/", icon: "🌐", color: "#ec4899", badge: "NEW" },
          { name: "Reel Script Studio", desc: "Blank page anxiety? 5,000+ hooks & frameworks to write killer 15-60s scripts", path: "/tools/social-media/reel-script-studio/", icon: "🎞️", color: "#38bdf8", badge: "NEW" },
          { name: "Social Media Tools Hub", desc: "Complete creator toolkit: Free caption, bio, script & engagement engines", path: "/tools/social-media/", icon: "🚀", color: "#6366f1" },
          { name: "Instagram Caption Generator", desc: "Stuck on captions? Generate viral, high-hook captions & hashtag stacks", path: "/tools/social-media/instagram-caption-generator", icon: "✨", color: "#e1306c" },
          { name: "Instagram Bio Generator", desc: "Need a sharp profile? Craft 150-char aesthetic bios that convert visitors", path: "/tools/social-media/instagram-bio-generator", icon: "👤", color: "#c13584" },
          { name: "Instagram ER Calculator", desc: "Temporarily unavailable", path: "/tools/social-media/instagram-engagement-rate-calculator", icon: "📊", color: "#94a3b8", disabled: true },
          { name: "TikTok ER Calculator", desc: "Are followers actually engaging? Check real engagement rate by views", path: "/tools/social-media/tiktok-engagement-rate-calculator", icon: "📱", color: "#000000" },
          { name: "TikTok Script Generator", desc: "Want viral TikTok scripts? High-retention 15s/30s/60s video outlines", path: "/tools/social-media/tiktok-script-generator", icon: "🎬", color: "#fe2c55" },
          { name: "Twitter/X Thread Generator", desc: "Want viral impressions? Transform one idea into a high-reach 5-7 tweet thread", path: "/tools/social-media/twitter-thread-generator", icon: "🧵", color: "#1da1f2" },
          { name: "LinkedIn Headline Generator", desc: "Get noticed by recruiters & clients: High-authority professional headlines", path: "/tools/social-media/linkedin-headline-generator", icon: "💼", color: "#0077b5" },
        ]
      },
      {
        title: "Text & Social Polish",
        subtitle: "Perfect your copy formatting and avoid awkward feed cut-offs",
        items: [
          { name: "LinkedIn Post Preview", desc: "Worried your hook gets cut off? Test 'see more' breakpoint & mobile feed preview", path: "/tools/social-media/linkedin-post-preview", icon: "👁️", color: "#0077b5" },
          { name: "LinkedIn Text Formatter", desc: "Bland text? Add bold, italic & Unicode emphasis to grab reader attention", path: "/tools/social-media/linkedin-text-formatter", icon: "💼", color: "#0077b5" },
          { name: "LinkedIn Character Counter", desc: "Avoid cut-offs: Real-time character, word count & optimal length meters", path: "/tools/social-media/linkedin-character-counter", icon: "🔢", color: "#0077b5" },
          { name: "Case Converter", desc: "Messy casing? Convert uppercase, lowercase, title case & camelCase in one click", path: "/convert-case/", icon: "🔠", color: "#E91E63" },
        ]
      },
      {
        title: "Color Palette & Design Systems",
        subtitle: "Can't pick colors? Test harmonic palettes on live UI components",
        items: [
          { name: "Color Palette Studio", desc: "Interactive Kolor hub: Test master color schemes on live UI cards", path: "/tools/color-palette/", icon: "🎨", color: "#6366f1", badge: "HUB" },
          { name: "Color Scheme Tools", desc: "Curated harmonic libraries: Explore gorgeous complementary & triadic sets", path: "/tools/design/color-scheme-tools", icon: "🌈", color: "#ec4899", badge: "POPULAR" },
          { name: "Palette Visualizer", desc: "Wonder how colors look on cards & buttons? Live component tester", path: "/tools/palette-visualizer", icon: "🖼️", color: "#4CAF50" },
          { name: "Color Palette Generator", desc: "Need quick inspiration? Generate fresh 5-color aesthetic harmonies", path: "/tools/color-palette-generator", icon: "🎨", color: "#FF5722" },
          { name: "Analogous Color Palette", desc: "Calm, cohesive color schemes based on neighboring color wheel hues", path: "/tools/design/analogous-color-palette", icon: "🎨", color: "#06b6d4" },
          { name: "Complementary Color Palette", desc: "High-contrast dynamic color schemes using opposite wheel shades", path: "/tools/design/complementary-color-palette", icon: "🎨", color: "#ef4444" },
          { name: "Monochromatic Color Palette", desc: "Sophisticated single-hue palettes with light, dark & saturated tints", path: "/tools/design/monochromatic-color-palette", icon: "🎨", color: "#8b5cf6" },
          { name: "Triadic Color Palette", desc: "Balanced vibrant three-tone harmony for energetic brand accents", path: "/tools/design/triadic-color-palette", icon: "🎨", color: "#f97316" },
          { name: "Split Complementary Palette", desc: "Nuanced contrast with softer tension than direct opposites", path: "/tools/design/split-complementary-color-palette", icon: "🎨", color: "#ec4899" },
          { name: "Square Color Palette", desc: "Evenly spaced four-color harmonies for rich, diverse UI designs", path: "/tools/design/square-color-palette", icon: "🎨", color: "#14b8a6" },
          { name: "Tetradic Color Palette", desc: "Double complementary palettes for rich, complex visual palettes", path: "/tools/design/tetradic-color-palette", icon: "🎨", color: "#3b82f6" },
          { name: "Palette Generator", desc: "Custom studio: Lock favorite colors and randomize the rest", path: "/tools/palette-generator", icon: "🎨", color: "#f59e0b" },
        ]
      },
      {
        title: "Color Utilities",
        subtitle: "Extract shades from photos, check contrast & inspect exact codes",
        items: [
           { name: "Image Picker", desc: "Love colors in a photo? Extract the dominant palette with 1 click", path: "/tools/image-picker", icon: "📷", color: "#E91E63" },
           { name: "Contrast checker", desc: "Is your text readable? Check WCAG AA/AAA accessibility compliance", path: "/tools/contrast-checker", icon: "👁️", color: "#009688" },
           { name: "Color Picker", desc: "Eyedropper tool to grab instant Hex, RGB, HSL values & tonal scales", path: "/tools/color-picker", icon: "🖌️", color: "#3F51B5" },
           { name: "Color Wheel", desc: "Interactive color wheel visualizer to explore color theory relationships", path: "/tools/design/color-wheel", icon: "🎨", color: "#9c27b0" },
         ]
      },
      {
        title: "Design & 3D Studio",
        subtitle: "Visualize real physical products & collaborate live",
        items: [
          { name: "3D Exhibition Stand", desc: "Interactive 4m × 3m expo booth builder, custom graphics & spatial layout visualizer", path: "/tools/design/3d-exhibition-stand/", icon: "🎪", color: "#f38b22", badge: "3D" },
          { name: "Design Distance Visualizer", desc: "Simulate viewing distances (0.5m-100m) & human optical acuity for prints & signs", path: "/tools/design/design-distance-visualizer/", icon: "👁️", color: "#38bdf8", badge: "3D" },
          { name: "Packaging Studio", desc: "Launching physical goods? Interactive 3D box, bottle & pouch visualizer", path: "/tools/design/packaging-studio", icon: "📦", color: "#6366f1", badge: "3D" },
          { name: "Client Workspace", desc: "Access restricted • Client workspace currently undergoing development update", path: "/workspace", icon: "💼", color: "#64748b", disabled: true, badge: "SOON" },
        ]
      },
      {
        title: "Typography Lab & Fonts",
        subtitle: "Letter anatomy, type education, live playground & font engineering",
        items: [
          { name: "Typography Lab Hub", desc: "Interactive type education, letter anatomy & custom type engineering", path: "/typography/", icon: "✒️", color: "#0284c7", badge: "HUB" },
          { name: "Glyph Outline Inspector", desc: "Inspect real font outlines, on/off-curve points, Bézier geometry & font tables", path: "/typography/glyph-outline-inspector/", icon: "🔬", color: "#0284c7", badge: "NEW" },
          { name: "Bézier Curve Studio", desc: "Interactive vector curve construction, handle ergonomics & continuity analysis", path: "/typography/bezier-curve-practice-studio/", icon: "📐", color: "#8b5cf6", badge: "NEW" },
          { name: "Kerning Pair Analyzer", desc: "Inspect GPOS tables, optical pair spacing, class matrices & tracking", path: "/typography/kerning-pair-analyzer/", icon: "↔️", color: "#ec4899", badge: "NEW" },
          { name: "Letterform Proportion Analyzer", desc: "Analyze glyph dimensions, optical overshoot, counterforms & width consistency", path: "/typography/letterform-proportion-analyzer/", icon: "⚖️", color: "#10b981", badge: "NEW" },
          { name: "Composition Challenge", desc: "Interactive typography layout studio: reconstruct designs, hierarchy & grids", path: "/typography/composition-challenge/", icon: "🎨", color: "#f59e0b", badge: "STUDIO" },
          { name: "Practice & Quiz Studio", desc: "Interactive typography assessments: anatomy, kerning, tracking & type scale tests", path: "/typography/practice/", icon: "🎯", color: "#3b82f6", badge: "PRACTICE" },
          { name: "Font ID Trainer", desc: "Train your visual eye to identify typefaces and letterform construction", path: "/typography/typeface-identification-trainer/", icon: "🧠", color: "#6366f1" },
          { name: "Typography Workspace", desc: "Consolidated private vault to save, reopen & version your typography projects", path: "/typography/workspace/", icon: "📁", color: "#64748b" },
          { name: "Letter Anatomy Lab", desc: "Inspect stems, counters, baselines, and vector glyph geometry", path: "/typography/letter-lab/", icon: "📏", color: "#0ea5e9" },
          { name: "Typography Academy", desc: "Structured lessons on font pairing, hierarchy & WCAG readability", path: "/typography/learn/", icon: "📖", color: "#10b981" },
          { name: "Typeface Playground", desc: "Live controls for size, weight, line-height & CSS export", path: "/typography/playground/", icon: "🎛️", color: "#8b5cf6" },
          { name: "Multilingual Font Viewer", desc: "Test 1,950+ open fonts with 1-click preview across Indian state scripts", path: "/resources/font-viewer/", icon: "🌐", color: "#f59e0b" },
          { name: "Custom Type Services", desc: "Bespoke typeface design, authorized script extensions & governance", path: "/typography/custom-fonts/", icon: "⚙️", color: "#0284c7" },
          { name: "Project Brief", desc: "Submit your custom typeface or font engineering requirements", path: "/typography/project-brief/", icon: "📋", color: "#0ea5e9" },
        ]
      },
      {
        title: "Image Optimization",
        subtitle: "Speed up page loading and enhance visual clarity",
        items: [
          { name: "Image compressor", desc: "Slow website? Compress JPG/PNG by up to 80% without losing quality", path: "/tools/image-optimization/image-compressor", icon: "📦", color: "#1565c0" },
          { name: "Image upscaler", desc: "Pixelated image? Smart AI upscaling to enhance clarity & resolution", path: "/tools/image-optimization/upscale-image", icon: "📈", color: "#4CAF50" },
        ]
      },
      {
        title: "Image Editing",
        subtitle: "Fast browser fixes without opening heavy desktop software",
        items: [
          { name: "Resize image", desc: "Wrong banner size? Scale dimensions pixel-perfect for web & socials", path: "/tools/image-editing/resize-image", icon: "📏", color: "#2196F3" },
          { name: "Crop image", desc: "Trim borders or fit strict 16:9, 1:1, 9:16 aspect ratios", path: "/tools/image-editing/crop-image", icon: "✂️", color: "#FF9800" },
          { name: "Rotate image", desc: "Fix orientation: 90°, 180° rotation & horizontal/vertical flips", path: "/tools/image-editing/rotate-image", icon: "🔄", color: "#673AB7" },
          { name: "Photo Editor", desc: "Full photo canvas: Adjust lighting, contrast, filters & crop", path: "/tools/image-editing/photo-editor", icon: "🖼️", color: "#4CAF50" },
        ]
      },
      {
        title: "Image Conversion",
        subtitle: "Convert formats in 1-click for compatibility and speed",
        items: [
          { name: "Convert to JPG", desc: "Convert HEIC or PNG to universally supported lightweight JPG", path: "/tools/image-conversion/convert-to-jpg", icon: "🔄", color: "#795548" },
          { name: "Convert to PNG", desc: "Preserve transparent backgrounds for logos & product shots", path: "/tools/image-conversion/convert-to-png", icon: "🖼️", color: "#667eea" },
          { name: "Convert to WebP", desc: "Google recommended next-gen format for ultra-fast web pages", path: "/tools/image-conversion/convert-to-webp", icon: "⚡", color: "#764ba2" },
          { name: "Convert to GIF", desc: "Create engaging lightweight looping animations from photos", path: "/tools/image-conversion/convert-to-gif", icon: "🎞️", color: "#f5576c" },
          { name: "Convert to BMP", desc: "Uncompressed bitmap format conversion for legacy systems", path: "/tools/image-conversion/convert-to-bmp", icon: "🖼️", color: "#4facfe" },
        ]
      },
      {
        title: "SEO Tools",
        subtitle: "Rank on Google, earn rich snippets & drive organic visits",
        items: [
          { name: "Schema Generator", desc: "Want rich snippets on Google? Generate FAQ, Article & Product JSON-LD", path: "/tools/seo/schema-generator", icon: "🧩", color: "#1565c0" },
          { name: "Meta Tag Generator", desc: "Boost search clicks: Create optimized title tags & Open Graph meta", path: "/tools/seo/meta-tag-generator", icon: "🏷️", color: "#7c3aed" },
          { name: "Robots Txt Validator", desc: "Check bot crawling: Ensure Googlebot isn't accidentally blocked", path: "/tools/seo/robots-txt-validator", icon: "🤖", color: "#4b5563" },
          { name: "Sitemap Visualizer", desc: "Inspect site structure: Crawl and explore all XML sitemap URLs", path: "/tools/seo/sitemap-visualizer", icon: "🌳", color: "#16a34a" },
          { name: "SERP Snippet Preview", desc: "See exactly how your web page appears on Google mobile & desktop", path: "/tools/seo/serp-snippet-preview", icon: "👁️", color: "#7c3aed" },
        ]
      },
      {
        title: "Keyword & Contact Tools",
        subtitle: "Scrape contacts & mix high-intent search terms",
        items: [
          { name: "Keyword Mixer", desc: "Generate high-intent long-tail search keyword combinations", path: "/tools/keyword/keyword-mixer", icon: "⌕", color: "#009688" },
          { name: "Email Extractor", desc: "Scrape and clean all email addresses from messy text or web pages", path: "/tools/email-extractor", icon: <FaEnvelope />, color: "#2563eb" },
        ]
      },
      {
        title: "Developer Utilities",
        subtitle: "Quick utilities for clean code, debugging & encoding",
        items: [
          { name: "Online Code Beautifier", desc: "Messy code? Auto-format JSON, JS, HTML, CSS with clean indentation", path: "/beautify", icon: "✨", color: "#6366f1" },
          { name: "JSON Formatter", desc: "Validate and prettify broken JSON payloads with syntax error checking", path: "/tools/text/json-formatter", icon: "📋", color: "#4CAF50" },
          { name: "Base64 Converter", desc: "Encode or decode strings and binary assets quickly in the browser", path: "/tools/text/base64-converter", icon: "🔄", color: "#FF9800" },
          { name: "UUID Generator", desc: "Generate cryptographically secure version-4 unique IDs instantly", path: "/tools/text/uuid-generator", icon: "🆔", color: "#9C27B0" },
          { name: "Hash Generator", desc: "Compute cryptographic MD5, SHA-256 and SHA-512 checksums instantly", path: "/tools/text/hash-generator", icon: "🔐", color: "#F44336" },
          { name: "Regex Tester", desc: "Debug and validate regular expressions with live pattern match highlights", path: "/tools/text/regex-tester", icon: "🧪", color: "#00BCD4" },
          { name: "Diff Checker", desc: "Compare two text blocks or code snippets and pinpoint differences", path: "/tools/text/diff-checker", icon: "📊", color: "#009688" },
          { name: "Instagram Banned Hashtags", desc: "Prevent shadowbans: Scan & remove penalized hashtags before posting", path: "/tools/social-media/instagram-banned-hashtag-remover", icon: "📱", color: "#673AB7" },
        ]
      },
      {
        title: "Generators & Math Calculators",
        subtitle: "Handy daily utilities, conversions & math shortcuts",
        items: [
          { name: "Qr Code Generator", desc: "Generate custom QR codes for menus, payment links, Wi-Fi & URLs", path: "/tools/generators/qr-code-generator", icon: "📱", color: "#4CAF50" },
          { name: "Favicon Generator", desc: "Generate multi-size web favicons for browser tabs & Apple devices", path: "/tools/generators/favicon-generator", icon: "🛠️", color: "#FF5722" },
          { name: "Gradient Generator", desc: "Craft ultra-smooth CSS linear & radial gradients with copyable CSS", path: "/tools/generators/gradient-generator", icon: "🎨", color: "#E91E63" },
          { name: "Lorem Ipsum Generator", desc: "Generate custom placeholder dummy text for mockups & wireframes", path: "/tools/generators/lorem-ipsum-generator", icon: "📝", color: "#607D8B" },
          { name: "Percentage Calculator", desc: "Solve percentage increases, discounts, profit margins & markups", path: "/tools/calculators/percentage-calculator", icon: "📊", color: "#FF9800" },
          { name: "Unit Converter", desc: "Convert length, area, speed, weight and temperature units quickly", path: "/tools/calculators/unit-converter", icon: "🔄", color: "#9C27B0" },
          { name: "Date & Time Calculator", desc: "Calculate exact day count, working days & date difference", path: "/tools/calculators/date-day-time-calculator", icon: "🧮", color: "#1565c0" },
        ]
      }
    ]
  },
  typography: {
    sections: [
      {
        title: "Font Engineering & Binary Vectors",
        subtitle: "Production-grade font file inspection, vector construction & variable axes",
        items: [
          { name: "Glyph Outline Inspector", desc: "Inspect Bézier points, coordinates & contour winding from TTF/OTF binaries", path: "/typography/glyph-outline-inspector/", icon: "🔬", color: "#6366f1", badge: "PRO" },
          { name: "Bézier Curve Practice Studio", desc: "Interactive vector construction, handle alignment & curvature continuity", path: "/typography/bezier-curve-practice-studio/", icon: "📐", color: "#38bdf8", badge: "LAB" },
          { name: "Binary Glyph Inspector", desc: "Inspect TTF/OTF table structures, glyph mappings, header flags & metadata", path: "/typography/glyph-inspector/", icon: "⚙️", color: "#f59e0b" },
          { name: "Glyph Repertoire & Features", desc: "Unicode coverage, localized glyph variations & OpenType layout features", path: "/typography/glyphs/", icon: "✨", color: "#10b981" },
          { name: "Variable Fonts Lab", desc: "Explore multi-axis variations (weight, width, slant, optical size) live", path: "/typography/variable-fonts/", icon: "🎛️", color: "#ec4899" },
          { name: "Font Modification & Hinting", desc: "Screen hinting, TTF delta instructions & font mastering standards", path: "/typography/font-modification/", icon: "🛡️", color: "#06b6d4" },
          { name: "CSS Typography & Token Rules", desc: "Author CSS clamp(), OpenType features & export design tokens", path: "/typography/css/", icon: "💻", color: "#2563eb" },
          { name: "Typography Token Exporter", desc: "Export W3C design tokens, Tailwind configs & CSS custom properties", path: "/typography/token-exporter/", icon: "📦", color: "#f97316" },
          { name: "Typography Workspace", desc: "Central workbench for live font experiments and font table analysis", path: "/typography/workspace/", icon: "📁", color: "#8b5cf6" },
          { name: "Medium Typography Studio", desc: "Multi-medium slide canvas editor with heuristic layout & squint blur tests", path: "/typography/medium-studio/", icon: "🖥️", color: "#6366f1" },
          { name: "Letter Anatomy Lab", desc: "Dissect glyph curves, counterforms, ascenders, serifs & terminals", path: "/typography/letter-lab/", icon: "📏", color: "#0284c7" },
          { name: "Anatomy of Type Explorer", desc: "Interactive anatomical guide to x-height, overshoot, and anatomy terms", path: "/typography/typeface-anatomy-explorer/", icon: "🔬", color: "#38bdf8" },
          { name: "Typography Playground", desc: "Live experimental canvas for line-height, weight & tracking testing", path: "/typography/playground/", icon: "🧪", color: "#a855f7" },
          { name: "Optical Illusion Laboratory", desc: "Study perceptual shifts: overshoot, irradiation & weight illusions", path: "/typography/optical-illusions/", icon: "🔮", color: "#06b6d4" },
        ]
      },
      {
        title: "Metrics, Spacing & Layout Calculators",
        subtitle: "Precision vertical rhythm, optical spacing, clamp scales & fluid type",
        items: [
          { name: "Type Scale Calculator", desc: "Generate mathematical modular scales with live responsive specimens", path: "/typography/type-scale/", icon: "📐", color: "#6366f1" },
          { name: "Vertical Rhythm Calculator", desc: "Harmonize paragraph leadings with root 4px/8px baseline grids", path: "/typography/vertical-rhythm/", icon: "📊", color: "#f59e0b" },
          { name: "Fluid Typography (clamp)", desc: "Calculate viewport-responsive CSS clamp() formulas with zero layout shift", path: "/typography/fluid-typography/", icon: "⚡", color: "#ec4899" },
          { name: "Fluid Type System Studio", desc: "Full responsive typographic design system & breakpoint generator", path: "/typography/fluid-type-system/", icon: "🌊", color: "#38bdf8" },
          { name: "Optimal Measure (Line Length)", desc: "Audit line lengths against optimal 45–75 characters per line standard", path: "/typography/line-length/", icon: "📏", color: "#10b981" },
          { name: "Typography Unit Converter", desc: "Precision converter between PX, REM, EM, PT, and percentage units", path: "/typography/unit-converter/", icon: "🔄", color: "#f97316" },
          { name: "Letter Spacing & Tracking Guide", desc: "Discover optimal tracking ranges for body copy and uppercase display text", path: "/typography/tracking-guide/", icon: "↔️", color: "#06b6d4" },
          { name: "WCAG Contrast Checker", desc: "Verify APCA & WCAG 2.2 AA/AAA contrast ratios against real backgrounds", path: "/typography/contrast-checker/", icon: "👁️", color: "#8b5cf6" },
          { name: "Readability & Legibility Lab", desc: "Audit typographic legibility, reading speed benchmarks & WCAG audits", path: "/typography/readability/", icon: "📖", color: "#10b981" },
          { name: "Typography Hierarchy Preview", desc: "Preview H1-H6 headings against modular type scales on realistic layouts", path: "/typography/hierarchy-preview/", icon: "📑", color: "#6366f1" },
          { name: "Kerning Pair Analyzer", desc: "Audit GPOS PairPos adjustments, class matrices & optical spacing", path: "/typography/kerning-pair-analyzer/", icon: "↔️", color: "#059669" },
          { name: "Kerning Studio & Shaping", desc: "Pair-specific glyph positioning, spacing calibration & browser shaping", path: "/typography/kerning/", icon: "🔤", color: "#d97706" },
          { name: "Letterform Proportion Analyzer", desc: "Measure dimensional ratios, overshoot, and counterform balance", path: "/typography/letterform-proportion-analyzer/", icon: "⚖️", color: "#ec4899" },
          { name: "Composition Studio Challenge", desc: "Reconstruct typographic hierarchy, modular grids & layouts on canvas", path: "/typography/composition-challenge/", icon: "🎨", color: "#8b5cf6" },
        ]
      },
      {
        title: "Typography Academy & Learning",
        subtitle: "Guided lessons, theory, letterform recognition quizzes & reference library",
        items: [
          { name: "Typography Academy (All Modules)", desc: "Comprehensive guided curriculum from foundations to advanced engineering", path: "/typography/learn/", icon: "🎓", color: "#06b6d4", badge: "HUB" },
          { name: "Lesson: Anatomy of Letterforms", desc: "Master ascenders, descenders, counters, spurs, serifs & terminals", path: "/typography/learn/anatomy-of-letterforms/", icon: "📘", color: "#6366f1" },
          { name: "Lesson: Modular Scales & Fluid Type", desc: "Musical ratios, base REM units & responsive clamp() formulas explained", path: "/typography/learn/modular-type-scales-and-fluid-typography/", icon: "📘", color: "#38bdf8" },
          { name: "Lesson: Principles of Dual-Font Pairing", desc: "Contrast vs harmony: pairing serifs, sans-serifs, and display faces", path: "/typography/learn/principles-of-dual-font-pairing/", icon: "📘", color: "#10b981" },
          { name: "Lesson: Kerning, Tracking & Spacing", desc: "Optical vs metric spacing, GPOS pair adjustments & text legibility", path: "/typography/learn/kerning-tracking-and-letterspacing/", icon: "📘", color: "#f59e0b" },
          { name: "Lesson: Variable Fonts & OT Axes", desc: "fvar tables, weight/width/optical size axes & performance savings", path: "/typography/learn/variable-fonts-and-open-type-axes/", icon: "📘", color: "#ec4899" },
          { name: "Lesson: Accessible Typography WCAG 2.2", desc: "APCA contrast, color perception, zoom reflow & dyslexia considerations", path: "/typography/learn/accessible-typography-wcag-22/", icon: "📘", color: "#8b5cf6" },
          { name: "Typography Practice & Quiz Lab", desc: "Hands-on quizzes & assessments across 6 curriculum levels with scoring", path: "/typography/practice/", icon: "🎯", color: "#2563eb" },
          { name: "Typeface ID Trainer", desc: "Train your visual eye to identify fonts, analyze serif styles & classify", path: "/typography/typeface-identification-trainer/", icon: "🧠", color: "#f59e0b" },
          { name: "Typography History Timeline", desc: "From Phoenician & Brahmi to modern digital desktop and web typography", path: "/typography/history-timeline/", icon: "🏛️", color: "#d97706" },
          { name: "Terminology Visualizer", desc: "Interactive encyclopedia covering 188+ essential typographic concepts", path: "/typography/terminology-visualizer/", icon: "📖", color: "#f97316" },
          { name: "Typography Reference Library", desc: "Technical checklists, OpenType specification sheets & designer guides", path: "/typography/resources/", icon: "📚", color: "#0284c7" },
          { name: "Font Pairing Studio", desc: "Harmonic font pairing engine with live editorial specimen previews", path: "/typography/pairing/", icon: "🎭", color: "#10b981" },
          { name: "UI & UX Typography Guide", desc: "Product design hierarchy, design system tokens, button & microcopy type", path: "/typography/ui-ux/", icon: "📱", color: "#6366f1" },
        ]
      },
      {
        title: "Services, Identity & Corporate Systems",
        subtitle: "Bespoke brand typeface development, Indian script engineering & licensing",
        items: [
          { name: "Custom Project Brief Wizard", desc: "5-step wizard to scope bespoke typefaces, Indic scripts & licenses", path: "/typography/project-brief/", icon: "📋", color: "#2563eb", badge: "WIZARD" },
          { name: "Custom Typeface Engineering", desc: "Bespoke brand typeface design from ultra-thin to black weights", path: "/typography/custom-fonts/", icon: "🎨", color: "#6366f1" },
          { name: "Brand Typography System Builder", desc: "Complete brand typographic guidelines, pairings & hierarchy audit", path: "/typography/brand-system/", icon: "🏷️", color: "#38bdf8" },
          { name: "Typography for Brand Identity", desc: "Strategic typographic positioning, brand voice & visual identity systems", path: "/typography/branding/", icon: "✨", color: "#ec4899" },
          { name: "Corporate Font Licensing", desc: "Enterprise multi-seat desktop, web, app, server & broadcast licensing", path: "/typography/corporate/", icon: "📄", color: "#f59e0b" },
          { name: "Multilingual & Indic Expansion", desc: "Complex script shaping & OT feature rules for Devanagari, Tamil & Arabic", path: "/typography/multilingual/", icon: "🌐", color: "#10b981" },
          { name: "Logotype & Lettering Studio", desc: "Bespoke typographic logos, visual emblems, and custom wordmarks", path: "/typography/logo-lettering/", icon: "✒️", color: "#8b5cf6" },
          { name: "Type Classification Guide", desc: "Explore Humanist, Transitional, Didone, Slab, Geometric & Grotesque", path: "/typography/classification/", icon: "📚", color: "#06b6d4" },
          { name: "Script History & Evolution", desc: "Chronological deep-dive into typographic development and epigraphy", path: "/typography/history/", icon: "📜", color: "#b45309" },
          { name: "Type Identification Quick Tool", desc: "Quick font family identification and visual attribute matching", path: "/typography/identification/", icon: "🔍", color: "#4338ca" },
          { name: "Optical Perception Lab", desc: "Visual compensation, irradiation, and stroke weight compensation", path: "/typography/optical-illusion-laboratory/", icon: "🔮", color: "#059669" },
          { name: "Interactive Practice Studio", desc: "Direct hands-on typographic layout and assessment environment", path: "/typography/practice-studio/", icon: "📐", color: "#0284c7" },
          { name: "Layout Composition Canvas", desc: "Interactive canvas layout challenge and hierarchy reconstruction", path: "/typography/composition/", icon: "🎨", color: "#9333ea" },
          { name: "Typography Lab Hub", desc: "Central headquarters for all Goafreet typography engineering & tools", path: "/typography/", icon: "🏛️", color: "#2563eb", badge: "HUB" },
        ]
      }
    ]
  },
  marketplace: {
    sections: [
      {
        title: "Amazon India (Profit & Ads)",
        subtitle: "Stop margin leakage: Know exact seller fees, FBA & safe ad limits",
        items: [
          { name: "Amazon Profit Calculator", desc: "Unsure about real profit? Calculate net payout after referral, closing & tax", path: "/tools/amazon/profit-calculator", icon: "▦", color: "#FF9900" },
          { name: "Amazon TACoS Calculator", desc: "Is advertising eating your organic profit? Track Total ACoS health", path: "/tools/amazon/tacos-calculator", icon: "📈", color: "#FF9900" },
          { name: "Amazon FBA Fee Calc", desc: "Estimate pick & pack, weight handling and fulfillment fees accurately", path: "/tools/amazon/fba-fee-calculator", icon: "📦", color: "#FF9900" },
          { name: "Amazon Storage Fee", desc: "Avoid long-term storage penalties: Forecast monthly warehouse holding costs", path: "/tools/amazon/fba-storage-fee-calculator", icon: "🏢", color: "#FF9900" },
          { name: "Amazon ACOS Calculator", desc: "Check ad profitability: Compare ad spend vs sales generated", path: "/tools/amazon/acos-calculator", icon: "📈", color: "#FF9900" },
          { name: "Amazon Break-Even ACOS", desc: "What is your maximum safe ad spend? Know the exact break-even threshold", path: "/tools/amazon/break-even-acos-calculator", icon: "⚖️", color: "#FF9900" },
          { name: "Amazon Ad ROI", desc: "Forecast return on ad spend before committing your monthly PPC budget", path: "/tools/amazon/advertising-roi-calculator", icon: "💰", color: "#FF9900" },
          { name: "Marketing Budget Planner", desc: "Plan seasonal and monthly budgets to hit target revenue goals", path: "/tools/amazon/marketing-budget-planner", icon: "📊", color: "#FF9900" },
          { name: "Launch Budget Calc", desc: "Launching a new ASIN? Estimate total review, PPC & honeymoon spend", path: "/tools/amazon/product-launch-budget-calculator", icon: "🚀", color: "#FF9900" },
          { name: "Amazon Coupon ROI", desc: "Are coupons driving profitable volume or just eroding margin? Calculate ROI", path: "/tools/amazon/coupon-roi-calculator", icon: "🏷️", color: "#FF9900" },
        ]
      },
      {
        title: "Amazon India (SEO & Ops)",
        subtitle: "Improve keyword ranks, listing quality & stay in stock",
        items: [
          { name: "Listing SEO Score", desc: "Is your listing indexed properly? Score backend keywords, title & bullets", path: "/tools/amazon/listing-seo-score-calculator", icon: "🔍", color: "#FF9900" },
          { name: "Listing Quality Grader", desc: "Review image counts, A+ content, bullet length & rating benchmarks", path: "/tools/amazon/listing-quality-grader", icon: "⭐", color: "#FF9900" },
          { name: "Super URL Creator", desc: "Build 2-step keyword attribution URLs to simulate organic search buys", path: "/tools/amazon/super-url-creator", icon: "🔗", color: "#FF9900" },
          { name: "Rank & Review Analyzer", desc: "Track organic positioning and monitor customer sentiment trends", path: "/tools/amazon/rank-review-analyzer", icon: "📊", color: "#FF9900" },
          { name: "Amazon Inventory Forecast", desc: "Avoid out-of-stock penalties: Forecast reorder dates and safety stock", path: "/tools/amazon/inventory-forecaster-amz", icon: "📦", color: "#FF9900" },
          { name: "Keyword Inventory Forecast", desc: "Forecast demand volume per keyword search demand", path: "/tools/keyword/inventory-forecaster-kw", icon: "⌕", color: "#FF9900" },
        ]
      },
      {
        title: "Flipkart Seller Tools",
        subtitle: "Protect Flipkart margins across Tier status, logistics & Big Billion Days",
        items: [
          { name: "Flipkart TACoS Calculator", desc: "Measure true ad dependency and total business profitability", path: "/tools/flipkart/tacos-calculator", icon: "🎯", color: "#2874F0" },
          { name: "Flipkart Break-Even Target", desc: "Calculate net settlement and maximum allowable ad cost per order", path: "/tools/flipkart/break-even-target", icon: "🎯", color: "#2874F0" },
          { name: "Flipkart Settlement to Price", desc: "Reverse calculate: Set your target in-hand profit to find selling price", path: "/tools/flipkart/settlement-to-price", icon: "🔄", color: "#2874F0" },
          { name: "Flipkart Shipping Fee", desc: "Estimate regional, national and local shipping fees accurately", path: "/tools/flipkart/shipping-fee-calculator", icon: "🚚", color: "#2874F0" },
          { name: "Smart Fulfilment ROI", desc: "Evaluate F-Assured benefits vs extra fulfillment operating costs", path: "/tools/flipkart/smart-fulfilment-roi", icon: "📦", color: "#2874F0" },
          { name: "Flipkart Ads ROI", desc: "Forecast PLA and PCA campaign returns and ad spend feasibility", path: "/tools/marketplace/in/flipkart-ads-roi-calculator", icon: "📈", color: "#2874F0" },
          { name: "BBD Marketing Budget", desc: "Plan Big Billion Days ad budget, discount strategy and profit targets", path: "/tools/flipkart/marketing-budget", icon: "📊", color: "#2874F0" },
          { name: "SuperCoin ROI", desc: "Evaluate participation in SuperCoin promotional discount events", path: "/tools/flipkart/supercoin-roi", icon: "🪙", color: "#2874F0" },
          { name: "FSN Listing Grader", desc: "Grade catalog readiness against Flipkart's latest listing algorithms", path: "/tools/flipkart/listing-quality-grader", icon: "⭐", color: "#2874F0" },
          { name: "Image Compliance", desc: "Avoid catalog rejection: Verify product images against Flipkart rules", path: "/tools/flipkart/image-compliance", icon: "🖼️", color: "#2874F0" },
          { name: "Keyword Rank Tracker", desc: "Track organic search positions for target high-traffic keywords", path: "/tools/flipkart/keyword-rank-tracker", icon: "🔍", color: "#2874F0" },
          { name: "Tier Defense Forecaster", desc: "Protect Gold/Silver tier perks by tracking dispatch & return thresholds", path: "/tools/flipkart/tier-defense-forecaster", icon: "🛡️", color: "#2874F0" },
        ]
      },
      {
        title: "Meesho Seller Tools",
        subtitle: "Win 0% commission selling: Guard against RTO losses & fake returns",
        items: [
          { name: "Meesho Break-Even Target", desc: "Price competitively while ensuring net positive profit per unit", path: "/tools/meesho/break-even-target", icon: "🎯", color: "#F43397" },
          { name: "Meesho RTO Cost Analyzer", desc: "Estimate courier return losses and safeguard your bottom line", path: "/tools/meesho/rto-cost-analyzer", icon: "📉", color: "#F43397" },
          { name: "Meesho Price Benchmarker", desc: "Benchmark catalog pricing against top marketplace competitors", path: "/tools/meesho/price-benchmarker", icon: "🏷️", color: "#F43397" },
          { name: "Meesho Ad ROAS", desc: "Measure cost-per-click efficiency on Meesho discovery ads", path: "/tools/meesho/ad-roas-calculator", icon: "📈", color: "#F43397" },
          { name: "Combo Margin Calculator", desc: "Bundle products into combos to increase Average Order Value (AOV)", path: "/tools/meesho/combo-margin-calculator", icon: "📦", color: "#F43397" },
          { name: "NDD Compliance Tracker", desc: "Track Next Day Dispatch scores to maintain platform visibility boost", path: "/tools/meesho/ndd-compliance-tracker", icon: "⚡", color: "#F43397" },
          { name: "Fraud Return Estimator", desc: "Model fake customer return percentages to price in safety buffers", path: "/tools/meesho/fraud-return-estimator", icon: "🛡️", color: "#F43397" },
          { name: "Visibility Analyzer", desc: "Pinpoint ranking suppressions and catalog discoverability bottlenecks", path: "/tools/meesho/visibility-analyzer", icon: "🔍", color: "#F43397" },
        ]
      },
      {
        title: "Indian Marketplaces",
        subtitle: "Multi-platform fee comparison & quick commission checks",
        items: [
          { name: "Flipkart Basic Comm.", desc: "Quick category-wise commission and fixed fee calculator", path: "/tools/marketplace/flipkart-commission-calculator", icon: "🛒", color: "#2874F0" },
          { name: "Flipkart Advanced Fee", desc: "Full breakdown of logistics, closing, referral & GST charges", path: "/tools/marketplace/in/flipkart-fee-calculator", icon: "◈", color: "#2874F0" },
          { name: "Meesho Profit Calc", desc: "Fast calculator for 0% commission models with shipping costs", path: "/tools/marketplace/in/meesho-profit-calculator", icon: "👜", color: "#F43397" },
          { name: "Myntra Commission", desc: "Fashion & lifestyle marketplace fee and return economics", path: "/tools/marketplace/in/myntra-commission-calculator", icon: "👗", color: "#FF3E6C" },
          { name: "Nykaa Commission", desc: "Beauty & personal care brand commission and marketing fees", path: "/tools/marketplace/in/nykaa-commission-calculator", icon: "💄", color: "#E91E63" },
          { name: "AJIO Commission", desc: "Reliance AJIO fashion seller take-rates and net earnings", path: "/tools/marketplace/in/ajio-commission-calculator", icon: "👕", color: "#1A1A1A" },
        ]
      },
      {
        title: "Quick Commerce",
        subtitle: "Dark store & 10-minute delivery margin calculators",
        items: [
          { name: "Blinkit Fee Calculator", desc: "Selling on Blinkit? Estimate dark-store margins & fulfillment fees", path: "/tools/quick-commerce/blinkit-fee-calculator", icon: "⚡", color: "#F3A823" },
          { name: "Zepto Fee Calculator", desc: "Selling on Zepto? Calculate commission, handling & net payout per order", path: "/tools/quick-commerce/zepto-fee-calculator", icon: "⚡", color: "#7E22CE" },
          { name: "Swiggy Instamart Fee", desc: "Selling on Instamart? Estimate grocery & FMCG marketplace fees", path: "/tools/quick-commerce/swiggy-instamart-fee-calculator", icon: "⚡", color: "#FC8019" },
          { name: "Quick Commerce Margin", desc: "Calculate net EBITDA margins across 10-minute grocery delivery orders", path: "/tools/quick-commerce/quick-commerce-margin-calculator", icon: "💰", color: "#22C55E" },
          { name: "QC Stock Cover Calc", desc: "Plan buffer stock: Avoid dark store stockouts during surge demand", path: "/tools/quick-commerce/quick-commerce-stock-cover-calculator", icon: "📦", color: "#3B82F6" },
        ]
      },
      {
        title: "Global Marketplaces (USA)",
        subtitle: "US Amazon, Walmart & cross-border dollar profit tools",
        items: [
          { name: "Amazon FBA Profit USA", desc: "Selling in the US? Calculate dollar profit margins after US FBA fees", path: "/tools/usa/amazon-fba-profit-calculator-usa", icon: "🇺🇸", color: "#0071CE" },
          { name: "Walmart Profit Calc", desc: "Sell on Walmart.com: Calculate marketplace fees & net payout in USD", path: "/tools/usa/walmart-marketplace-profit-calculator", icon: "🏪", color: "#0071CE" },
          { name: "Amazon PPC ACOS USA", desc: "Measure US Amazon sponsored products efficiency & campaign ACOS", path: "/tools/usa/amazon-ppc-acos-calculator-usa", icon: "📈", color: "#0071CE" },
          { name: "US Market Fee Comp.", desc: "Compare take-rates across US Amazon, Walmart & eBay in one view", path: "/tools/usa/us-marketplace-fee-comparison", icon: "⚖️", color: "#0071CE" },
          { name: "Amazon Listing SEO USA", desc: "Score US product listing readiness against A9 algorithm standards", path: "/tools/usa/amazon-listing-seo-score-checker-usa", icon: "🔍", color: "#0071CE" },
          { name: "US Reorder Point Calc", desc: "Account for sea freight lead times: Calculate optimal US reorder days", path: "/tools/usa/inventory-reorder-point-calculator-usa", icon: "📦", color: "#0071CE" },
          { name: "Amazon Storage USA", desc: "Estimate US monthly & aged inventory storage surcharge fees", path: "/tools/usa/amazon-fba-storage-fee-calculator-usa", icon: "🏢", color: "#0071CE" },
          { name: "Amazon Launch USA", desc: "Plan US launch budget: Vine reviews, PPC spend & honeymoon phase", path: "/tools/usa/amazon-product-launch-budget-usa", icon: "🚀", color: "#0071CE" },
          { name: "US Marketplace ROI", desc: "Forecast total return on capital for North American marketplace expansion", path: "/tools/usa/marketplace-roi-calculator-usa", icon: "💰", color: "#0071CE" },
          { name: "Buy Box Loss USA", desc: "Quantify revenue lost when suppressed or hijacked from Buy Box", path: "/tools/usa/amazon-buy-box-loss-calculator-usa", icon: "⚠️", color: "#0071CE" },
          { name: "US Return Loss Calc", desc: "Model cross-border customer return write-offs and liquidation losses", path: "/tools/usa/marketplace-return-loss-calculator-usa", icon: "📉", color: "#0071CE" },
        ]
      },
      {
        title: "Multi-Marketplace Tools",
        subtitle: "Cross-platform seller tools & margin protection",
        items: [
          { name: "Marketplace Tools Hub", desc: "All-in-one hub: 30+ free fee, profit, ad & compliance calculators", path: "/tools/marketplace", icon: "🏪", color: "#2563eb" },
          { name: "Marketplace Profit Calculator", desc: "Selling across platforms? Input cost & price to compare all payouts", path: "/tools/marketplace/marketplace-calculator", icon: "🧮", color: "#1565c0" },
          { name: "Amazon Fee Calculator", desc: "Find exact Amazon referral, closing & FBA fees by product category", path: "/tools/marketplace/amazon-fee-calculator", icon: "📦", color: "#FF9900" },
          { name: "Flipkart Commission Calc", desc: "Fast category commission lookup for Flipkart India sellers", path: "/tools/marketplace/flipkart-commission-calculator", icon: "🛒", color: "#2874F0" },
          { name: "GST Profit Calculator", desc: "Avoid tax surprises: Calculate net profits with 5%, 12%, 18% or 28% GST", path: "/tools/marketplace/in/gst-profit-calculator", icon: "🏛️", color: "#2874F0" },
          { name: "Marketplace Comparison", desc: "Side-by-side fee comparison: Amazon vs Flipkart vs Meesho vs Blinkit", path: "/tools/marketplace/in/marketplace-comparison-tool", icon: "⚖️", color: "#2874F0" },
          { name: "Return Loss Calculator", desc: "Quantify real cost of customer returns: Courier fees & reverse logistics", path: "/tools/marketplace/in/marketplace-return-loss-calculator-in", icon: "📉", color: "#2874F0" },
          { name: "Discount Planner", desc: "Plan flash sale discounts without eroding minimum acceptable margin", path: "/tools/marketplace/in/marketplace-discount-planner", icon: "🏷️", color: "#2874F0" },
          { name: "Price Parity Calculator", desc: "Maintain consistent profit margins across different marketplace rules", path: "/tools/marketplace/in/marketplace-price-parity-calculator", icon: "⚖️", color: "#2874F0" },
          { name: "Reorder Point Calc", desc: "Know exactly when to reorder inventory based on sales velocity", path: "/tools/marketplace/in/marketplace-reorder-point-calculator", icon: "📦", color: "#2874F0" },
        ]
      },
    ]
  },
  services: {
    highlights: servicesHighlights,
    sections: megaMenuSections,
  },
  resources: {
    highlights: [
      { name: "Instagram inspiration", desc: "Still puzzled what content to make? 100+ creator teardowns, hooks & playbooks", path: "/instagram-insights", icon: "🎯", color: "#E91E63" },
      { name: "Platform updates", desc: "Sudden algorithm or traffic shift? Official Google, Meta & Amazon changes explained", path: "/resources/platform-updates", icon: "⚡", color: "#3B82F6" },
      { name: "Website insights", desc: "Low conversions? 50+ proven web psychology facts that boost sales & engagement", path: "/facts-about-website-designing", icon: "💡", color: "#FF9800" },
      { name: "Case studies", desc: "Want proof before hiring? Real-world client turnarounds, metrics & revenue impact", path: "/industry-insights", icon: "📊", color: "#4CAF50" }
    ],
    sections: [
      {
        title: "Learning center",
        subtitle: "Level up your brand: Real success stories, benchmarks & growth playbooks",
        items: [
          { name: "Instagram intelligence", desc: "Still puzzled what content to make? 100+ proven creator playbooks, hooks & teardowns", path: "/instagram-insights", icon: "📸", color: "#EC4899", badge: "HOT" },
          { name: "Platform updates", desc: "Sudden traffic shift? Official Google, Meta, Ads & marketplace algorithm changes", path: "/resources/platform-updates", icon: "⚡", color: "#3B82F6" },
          { name: "Blog & insights", desc: "Need practical growth advice? Actionable marketing tactics & execution guides", path: "/blog", icon: "📝", color: "#2196F3" },
          { name: "Social Media Guide", desc: "Lost on social strategy? Step-by-step roadmap to scale followers & organic reach", path: "/social-media-strategy-guide/", icon: "📱", color: "#ec4899" },
          { name: "Case studies", desc: "Want proof before starting? Real-world client turnarounds, metrics & revenue impact", path: "/industry-insights", icon: "📊", color: "#4CAF50" },
          { name: "Research studies", desc: "Access restricted • Enterprise intelligence repository currently under strategic update", path: "/research-and-case-studies", icon: "🔬", color: "#9C27B0", disabled: true, badge: "SOON" },
          { name: "Documentation", desc: "Technical guidance: SEO knowledge base, schema rules & developer references", path: "/tools/seo/seo-knowledge-base", icon: "📚", color: "#FF9800" },
        ],
      },
      {
        title: "Brand resources",
        subtitle: "Stuck on branding? Ready-to-use blueprints, palettes, typography & UI",
        items: [
          { name: "Instagram inspiration", desc: "Unsure what content converts? 11 industry playbooks, viral teardowns & reels", path: "/instagram-insights", icon: "🎯", color: "#E91E63", badge: "POPULAR" },
          { name: "Branding inferno", desc: "Starting a brand? Ready-to-steal identity playbooks, brand voice & positioning", path: "/instagram-channel/branding-inferno", icon: "🔥", color: "#E91E63" },
          { name: "Marketing inferno", desc: "Stuck getting customers? Actionable go-to-market funnels & campaign templates", path: "/instagram-channel/digital-marketing-inferno", icon: "📈", color: "#2196F3" },
          { name: "UI inferno", desc: "Designing an app or site? High-converting UI/UX patterns & wireframe layouts", path: "/instagram-channel/ui-inferno", icon: "🎨", color: "#9C27B0" },
          { name: "Palette inferno", desc: "Can't pick matching colors? Curated aesthetic palettes with exact hex codes", path: "/instagram-channel/palette-inferno", icon: "🎨", color: "#FF5722" },
          { name: "Font inferno", desc: "Don't know which fonts look good? Tested typography pairings for web & print", path: "/instagram-channel/font-inferno", icon: "📝", color: "#795548" },
          { name: "Logo inferno", desc: "Need logo inspiration? Master visual marks, emblems & iconic brand references", path: "/instagram-channel/logo-inferno", icon: "⭐", color: "#607D8B" },
        ],
      },
      {
        title: "Innovation & Technology",
        subtitle: "Explore what's next: Breakthrough tech, repos & official announcements",
        items: [
          { name: "Innovation Explorer", desc: "Searching for cutting-edge tech? Global repository, open-source & AI registry", path: "/innovation", icon: "🌐", color: "#10b981", badge: "NEW" },
          { name: "Technology News", desc: "Keep ahead of the industry: Official tech releases, AI updates & engineering logs", path: "/technology-news", icon: "📰", color: "#2563eb", badge: "NEW" },
        ],
      },
      {
        title: "Freemium space",
        subtitle: "Free high-impact audits, interactive books & conversion insights",
        items: [
          { name: "Free PDF Books & E-Books", desc: "Read free 3D flipbook guides on branding, UI/UX, and marketing strategy", path: "/freemium-space", icon: "📚", color: "#1565c0", badge: "FREE" },
          { name: "Website insights", desc: "Low website conversions? 50+ proven web psychology facts that boost sales", path: "/facts-about-website-designing", icon: "💡", color: "#FF9800" },
        ],
      },
    ],
  },
};

const DEFAULT_PINNED_TOOLS = [
  { name: "Color Palette Studio", desc: "Can't match brand colors? Interactive master palette engine & visualizer", path: "/tools/color-palette/", icon: "🎨", color: "#ec4899", badge: "NEW" },
  { name: "Packaging Studio", desc: "Need 3D box mockups? Interactive packaging design & visualizer", path: "/tools/design/packaging-studio", icon: "📦", color: "#6366f1", badge: "3D" },
  { name: "Reel Script Studio", desc: "Don't know what to film? 5,000+ viral hooks & story script editor", path: "/tools/social-media/reel-script-studio/", icon: "🎞️", color: "#38bdf8", badge: "NEW" },
  { name: "Palette Visualizer", desc: "How do colors look on real UI? Live component color tester", path: "/tools/palette-visualizer", icon: "🖼️", color: "#10b981" },
  { name: "Amazon Fee Calculator", desc: "Losing margin? Calculate exact referral, FBA & storage costs", path: "/tools/marketplace/amazon-fee-calculator", icon: "📦", color: "#f59e0b" },
  { name: "Marketplace Profit Calculator", desc: "Multi-platform seller? Find exact net profit & break-even", path: "/tools/marketplace/marketplace-calculator", icon: "🧮", color: "#2563eb" },
  { name: "Flipkart Advanced Fee", desc: "Selling on Flipkart? Category fees & commission breakdown", path: "/tools/marketplace/in/flipkart-fee-calculator", icon: "🛒", color: "#2874F0" },
  { name: "Image compressor", desc: "Slow website? Compress JPG/PNG up to 80% with 0 quality loss", path: "/tools/image-optimization/image-compressor", icon: "📦", color: "#1565c0" },
  { name: "Color Picker", desc: "Extract exact shades: Instant Hex, RGB & HSL eyedropper values", path: "/tools/color-picker", icon: "🖌️", color: "#3F51B5" }
];



const getSmartIcon = (name) => {
  if (!name) return <FaTools />;
  const n = name.toLowerCase();
  
  // Images
  if (n.includes('compressor')) return <FaCompress />;
  if (n.includes('upscaler')) return <FaExpandArrowsAlt />;
  if (n.includes('resize')) return <FaArrowsAlt />;
  if (n.includes('crop')) return <FaCrop />;
  if (n.includes('rotate')) return <FaSyncAlt />;
  if (n.includes('photo editor')) return <FaMagic />;
  if (n.includes('jpg')) return <FaImage />;
  if (n.includes('png')) return <FaImage />;
  if (n.includes('webp')) return <FaFileImage />;
  if (n.includes('gif')) return <FaFilm />;
  if (n.includes('bmp')) return <FaImages />;
  
  // Colors & 3D Design
  if (n.includes('packaging')) return <FaBox />;
  if (n.includes('workspace')) return <FaBriefcase />;
  if (n.includes('color palette studio') || n.includes('kolor hub')) return <FaPalette />;
  if (n.includes('color scheme')) return <FaPalette />;
  if (n.includes('palette visualizer')) return <FaPalette />;
  if (n.includes('palette generator') && !n.includes('color')) return <FaBrush />;
  if (n.includes('color palette generator')) return <FaPaintBrush />;
  if (n.includes('analogous')) return <FaPaintRoller />;
  if (n.includes('complementary') && !n.includes('split')) return <FaAdjust />;
  if (n.includes('monochromatic')) return <FaTint />;
  if (n.includes('triadic')) return <FaLayerGroup />;
  if (n.includes('split complementary')) return <FaFill />;
  if (n.includes('square color')) return <FaBorderAll />;
  if (n.includes('tetradic')) return <FaThLarge />;
  if (n.includes('image picker')) return <FaMousePointer />;
  if (n.includes('contrast checker')) return <FaEye />;
  if (n.includes('color picker')) return <FaEyeDropper />;
  if (n.includes('tailwind colors')) return <FaWind />;
  
  // SEO & Dev
  if (n.includes('schema generator')) return <FaCodeBranch />;
  if (n.includes('meta tag generator')) return <FaTags />;
  if (n.includes('robots txt')) return <FaRobot />;
  if (n.includes('seo knowledge')) return <FaBookOpen />;
  if (n.includes('snippet preview')) return <FaSearchPlus />;
  if (n.includes('sitemap visualizer')) return <FaSitemap />;
  if (n.includes('keyword mixer')) return <FaRandom />;
  if (n.includes('code beautifier')) return <FaCode />;
  if (n.includes('json formatter')) return <FaCode />;
  if (n.includes('base64')) return <FaExchangeAlt />;
  if (n.includes('uuid')) return <FaFingerprint />;
  if (n.includes('hash generator')) return <FaLock />;
  if (n.includes('regex tester')) return <FaSearch />;
  if (n.includes('diff checker')) return <FaColumns />;
  
  // Social & Text
  if (n.includes('reel script') || n.includes('reel studio')) return <FaVideo />;
  if (n.includes('email extractor')) return <FaEnvelopeOpenText />;
  if (n.includes('linkedin post preview')) return <FaLinkedinIn />;
  if (n.includes('linkedin text formatter')) return <FaTextHeight />;
  if (n.includes('linkedin character counter')) return <FaSortNumericUp />;
  if (n.includes('case converter')) return <FaFont />;
  if (n.includes('instagram caption')) return <FaInstagram />;
  if (n.includes('instagram bio')) return <FaUserEdit />;
  if (n.includes('instagram er')) return <FaCalculator />;
  if (n.includes('banned hashtag')) return <FaHashtag />;
  if (n.includes('tiktok er')) return <FaTiktok />;
  if (n.includes('tiktok script')) return <FaVideo />;
  if (n.includes('twitter') || n.includes('x thread')) return <FaTwitter />;
  if (n.includes('social media tools')) return <FaHashtag />;
  
  // Generators & Calculators
  if (n.includes('favicon')) return <FaStar />;
  if (n.includes('gradient')) return <FaAdjust />;
  if (n.includes('lorem ipsum')) return <FaAlignLeft />;
  if (n.includes('qr code')) return <FaQrcode />;
  if (n.includes('date, day')) return <FaCalendarAlt />;
  if (n.includes('percentage')) return <FaPercentage />;
  if (n.includes('unit converter')) return <FaBalanceScale />;
  
  // Amazon
  if (n.includes('amazon profit')) return <FaMoneyBillWave />;
  if (n.includes('amazon tacos')) return <FaChartLine />;
  if (n.includes('amazon fba fee')) return <FaBox />;
  if (n.includes('amazon storage')) return <FaWarehouse />;
  if (n.includes('amazon acos')) return <FaChartPie />;
  if (n.includes('amazon break-even')) return <FaBalanceScaleRight />;
  if (n.includes('amazon ad roi')) return <FaHandHoldingUsd />;
  if (n.includes('marketing budget')) return <FaPiggyBank />;
  if (n.includes('launch budget')) return <FaRocket />;
  if (n.includes('amazon coupon')) return <FaTicketAlt />;
  if (n.includes('listing seo score')) return <FaCheckDouble />;
  if (n.includes('listing quality grader')) return <FaAward />;
  if (n.includes('super url')) return <FaLink />;
  if (n.includes('rank & review')) return <FaStarHalfAlt />;
  if (n.includes('amazon inventory')) return <FaCubes />;
  if (n.includes('keyword inventory')) return <FaKeyboard />;
  
  // Flipkart
  if (n.includes('flipkart tacos')) return <FaChartLine />;
  if (n.includes('flipkart break-even')) return <FaBullseye />;
  if (n.includes('flipkart settlement')) return <FaRupeeSign />;
  if (n.includes('flipkart shipping')) return <FaTruck />;
  if (n.includes('smart fulfilment')) return <FaBolt />;
  if (n.includes('flipkart ads roi')) return <FaAd />;
  if (n.includes('bbd marketing')) return <FaShoppingBag />;
  if (n.includes('supercoin')) return <FaCoins />;
  if (n.includes('fsn listing grader')) return <FaClipboardCheck />;
  if (n.includes('image compliance')) return <FaShieldAlt />;
  if (n.includes('keyword rank tracker')) return <FaTrophy />;
  if (n.includes('tier defense')) return <FaShieldVirus />;
  if (n.includes('flipkart basic')) return <FaPercent />;
  if (n.includes('flipkart advanced')) return <FaCalculator />;
  
  // Meesho & Others
  if (n.includes('meesho break-even')) return <FaBullseye />;
  if (n.includes('meesho rto')) return <FaUndoAlt />;
  if (n.includes('meesho price')) return <FaBalanceScale />;
  if (n.includes('meesho ad roas')) return <FaBullhorn />;
  if (n.includes('combo margin')) return <FaLayerGroup />;
  if (n.includes('ndd compliance')) return <FaShippingFast />;
  if (n.includes('fraud return')) return <FaUserSecret />;
  if (n.includes('visibility analyzer')) return <FaEye />;
  if (n.includes('meesho profit')) return <FaMoneyCheckAlt />;
  if (n.includes('myntra')) return <FaTshirt />;
  if (n.includes('nykaa')) return <FaPumpSoap />;
  if (n.includes('ajio')) return <FaGem />;
  if (n.includes('zepto')) return <FaMotorcycle />;
  if (n.includes('blinkit')) return <FaStopwatch />;

  
  // Global & USA
  if (n.includes('usa')) return <FaGlobeAmericas />;
  if (n.includes('walmart')) return <FaStore />;
  if (n.includes('gst')) return <FaFileInvoiceDollar />;
  if (n.includes('comparison') || n.includes('parity')) return <FaBalanceScale />;
  if (n.includes('discount')) return <FaTags />;
  if (n.includes('return loss')) return <FaChartArea />;
  if (n.includes('universal market') || n.includes('marketplace profit')) return <FaGlobe />;
  
  // Resources & Insights
  if (n.includes('updates')) return <FaNewspaper />;
  if (n.includes('blog')) return <FaBook />;
  if (n.includes('intelligence')) return <FaUsers />;
  if (n.includes('case studies')) return <FaPencilAlt />;
  if (n.includes('research')) return <FaGraduationCap />;
  if (n.includes('documentation')) return <FaFileSignature />;
  
  // Inferno / Design
  if (n.includes('branding')) return <FaPaintBrush />;
  if (n.includes('marketing inferno')) return <FaBullhorn />;
  if (n.includes('ui inferno')) return <FaDesktop />;
  if (n.includes('palette inferno')) return <FaPalette />;
  if (n.includes('font') || n.includes('typography') || n.includes('glyph') || n.includes('letter lab') || n.includes('kerning') || n.includes('type scale') || n.includes('woff2') || n.includes('opentype') || n.includes('truetype')) return <FaFont />;
  if (n.includes('logo inferno')) return <FaDraftingCompass />;
  if (n.includes('website insights')) return <FaGlobe />;
  if (n.includes('instagram inspiration')) return <FaInstagram />;

  // Catch alls
  if (n.includes('calculator')) return <FaCalculator />;
  if (n.includes('generator')) return <FaCog />;
  if (n.includes('visualizer') || n.includes('checker') || n.includes('preview')) return <FaEye />;
  if (n.includes('formatter') || n.includes('converter')) return <FaPlug />;
  if (n.includes('database')) return <FaDatabase />;
  
  return <FaTools />;
};

const getItemIcon = (item, index = 0) => {
  return getSmartIcon(item.name);
};

// Strict normalization helper
const normPath = (p) => (p || "").toString().toLowerCase().replace(/\/+$/, "") || "/";

function Header() {
  const { allSitePage } = useStaticQuery(graphql`
    query HeaderRouteIndex {
      allSitePage {
        nodes {
          path
        }
      }
    }
  `);

  const discoveredRoutes = getPublicRouteItems(allSitePage.nodes);

  const toolsMenuData = {
    title: 'Tools',
    sections: navigationData.tools.sections
  };
  const typographyMenuData = {
    title: 'Typography Lab',
    sections: navigationData.typography.sections
  };
  const marketplaceMenuData = {
    title: 'E-Commerce',
    sections: navigationData.marketplace.sections
  };
  const servicesMenu = {
    title: 'Services',
    highlights: navigationData.services.highlights,
    sections: navigationData.services.sections
  };
  const resourcesMenu = {
    title: 'Resources',
    sections: navigationData.resources.sections
  };

  const siteIndexMap = new Map();

  [
    { key: 'tools', menu: toolsMenuData }, 
    { key: 'typography', menu: typographyMenuData },
    { key: 'marketplace', menu: marketplaceMenuData }, 
    { key: 'services', menu: servicesMenu }, 
    { key: 'resources', menu: resourcesMenu }
  ].forEach(({ key, menu }) => {
    menu.sections.forEach(sec => {
      sec.items.forEach(it => {
        const p = normPath(it.path);
        const brand = /amazon/.test(p) ? 'amazon' : /flipkart/.test(p) ? 'flipkart' : /meesho/.test(p) ? 'meesho' : /walmart/.test(p) ? 'walmart' : /shopify/.test(p) ? 'shopify' : /ebay/.test(p) ? 'ebay' : null;
        siteIndexMap.set(p, { path: it.path, title: it.name, desc: it.desc, category: key, brand });
      });
    });
  });

  discoveredRoutes.forEach(route => {
    const p = normPath(route.path);
    if (!siteIndexMap.has(p) && !p.includes('exhibition-event-branding')) {
      const name = route.name || p.split('/').filter(Boolean).pop().replace(/-/g, ' ');
      siteIndexMap.set(p, { 
        path: route.path, 
        title: name.charAt(0).toUpperCase() + name.slice(1), 
        desc: route.desc || '', 
        category: 'other', 
        brand: null 
      });
    }
  });

  const siteIndex = Array.from(siteIndexMap.values());

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
  const isLg = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
  const isMobile = !isDesktop;

  const appBarRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(105);

  useEffect(() => {
    const updateHeaderHeight = () => {
      if (appBarRef.current) {
        setHeaderHeight(appBarRef.current.offsetHeight);
      }
    };
    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
    return () => window.removeEventListener("resize", updateHeaderHeight);
  }, []);

  const handleMobileCategoryClick = (categoryKey) => {
    setMobileExpanded((prev) => ({ ...prev, [categoryKey]: true }));
    setMobileOpen(true);
  };

  const [searchOverlayOpen, setSearchOverlayOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const openSearchOverlay = () => setSearchOverlayOpen(true);
  const closeSearchOverlay = () => setSearchOverlayOpen(false);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const menuPointerInside = useRef(false);
  const [mobileExpanded, setMobileExpanded] = useState({});
  const [selectedServiceFamilySlug, setSelectedServiceFamilySlug] = useState('brand-creative');
  const [mobileExpandedServiceFamily, setMobileExpandedServiceFamily] = useState({});
  const toggleMobileServiceFamily = (slug) => {
    setMobileExpandedServiceFamily((prev) => ({ ...prev, [slug]: !prev[slug] }));
  };
  const [frequentTools, setFrequentTools] = useState(DEFAULT_PINNED_TOOLS);

  // Publisher logo renderer component
  const renderPublisherLogo = (pubName, size = 14) => {
    switch (pubName) {
      case "Google":
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" style={{ display: "block" }}>
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
          </svg>
        );
      case "AWS":
        return <FaAws size={size} color="#FF9900" style={{ display: "block" }} />;
      case "GitHub":
        return <FaGithub size={size} style={{ display: "block", color: "var(--text-primary)" }} />;
      case "NVIDIA":
        return <SiNvidia size={size} color="#76B900" style={{ display: "block" }} />;
      case "OpenAI":
        return (
          <svg width={size} height={size} viewBox="0 0 24 24" fill="#10a37f" style={{ display: "block" }}>
            <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1683a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4947zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1684a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.8956zm16.0993 3.8558L12.5973 8.3829l2.02-1.1636a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.402-.6862zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.0068 9.2298V6.8974a.0662.0662 0 0 1 .0283-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM12 10.5518l2.9238 1.6885v3.3732l-2.9238 1.6885-2.9238-1.6885v-3.3732L12 10.5518z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  // Live Verified Technology News Stream for Header Bar
  const techHeadlines = useMemo(() => [
    { title: "Client SDK generation in the open", publisher: "Google", color: "#4285F4" },
    { title: "Colab is now part of Google AI plan", publisher: "Google", color: "#4285F4" },
    { title: "Antigravity SDK: Support for Local AI Models", publisher: "Google", color: "#4285F4" },
    { title: "Graviton4 Cloud Compute Architecture", publisher: "AWS", color: "#FF9900" },
    { title: "Copilot Extensions & Enterprise Agents", publisher: "GitHub", color: "#8b5cf6" },
    { title: "Blackwell Ultra & High-Speed AI Systems", publisher: "NVIDIA", color: "#76B900" },
    { title: "Frontier Models & Structured Agent Outputs", publisher: "OpenAI", color: "#10a37f" },
  ], []);

  const [techHeadlineIdx, setTechHeadlineIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTechHeadlineIdx((prev) => (prev + 1) % techHeadlines.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [techHeadlines.length]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        const stored = JSON.parse(localStorage.getItem('goafreet_frequentTools') || '{}');
        const sorted = Object.entries(stored)
          .sort((a, b) => b[1].count - a[1].count)
          .slice(0, 5) 
          .map(entry => entry[1].item);
        
        if (sorted.length > 0) {
          setFrequentTools(sorted);
        }
      } catch (e) {
        console.error("Local Storage Error", e);
      }
    }
  }, []);

  const trackToolClick = (item) => {
    if (typeof window !== 'undefined') {
      try {
        const stored = JSON.parse(localStorage.getItem('goafreet_frequentTools') || '{}');
        if (!stored[item.path]) {
          stored[item.path] = { count: 0, item: item };
        }
        stored[item.path].count += 1;
        localStorage.setItem('goafreet_frequentTools', JSON.stringify(stored));

        const sorted = Object.entries(stored)
          .sort((a, b) => b[1].count - a[1].count)
          .slice(0, 5)
          .map(entry => entry[1].item);
        
        setFrequentTools(sorted);
      } catch (e) {
        console.error("Local Storage Error", e);
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setActiveMenu(null);
        menuPointerInside.current = false;
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleMobileExpand = (section) => setMobileExpanded((prev) => ({ ...prev, [section]: !prev[section] }));

  const handleMenuHover = (menuType) => {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    setActiveMenu(menuType);
  };

  const handleMenuToggle = (menuType) => {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    setActiveMenu((prev) => {
      if (prev === menuType) {
        menuPointerInside.current = false;
        return null;
      }
      return menuType;
    });
  };

  const handleMenuLeave = () => {
    const timeout = setTimeout(() => {
      if (!menuPointerInside.current) setActiveMenu(null);
    }, 700);
    setHoverTimeout(timeout);
  };

  const handleMenuEnter = () => {
    menuPointerInside.current = true;
    if (hoverTimeout) clearTimeout(hoverTimeout);
  };

// Platform updates helpers
const renderPlatformIcon = (key) => {
  switch (key) {
    case 'google':
    case 'google-ads':
      return <FaGoogle size={11} />;
    case 'meta':
    case 'whatsapp':
      return <FaFacebook size={11} />;
    case 'amazon':
      return <FaAmazon size={11} />;
    case 'shopify':
      return <FaShopify size={11} />;
    case 'linkedin':
      return <FaLinkedin size={11} />;
    default:
      return <FaStore size={11} />;
  }
};

const getPlatformBadgeColor = (key) => {
  switch (key) {
    case 'google':
      return { bg: 'rgba(66, 133, 244, 0.12)', text: '#1a73e8', border: 'rgba(66, 133, 244, 0.25)' };
    case 'google-ads':
      return { bg: 'rgba(234, 67, 53, 0.12)', text: '#d93025', border: 'rgba(234, 67, 53, 0.25)' };
    case 'meta':
    case 'whatsapp':
      return { bg: 'rgba(6, 104, 225, 0.12)', text: '#0668e1', border: 'rgba(6, 104, 225, 0.25)' };
    case 'amazon':
      return { bg: 'rgba(255, 153, 0, 0.12)', text: '#d97706', border: 'rgba(255, 153, 0, 0.25)' };
    case 'flipkart':
      return { bg: 'rgba(40, 116, 240, 0.12)', text: '#1565c0', border: 'rgba(40, 116, 240, 0.25)' };
    case 'shopify':
      return { bg: 'rgba(150, 191, 72, 0.15)', text: '#2e7d32', border: 'rgba(150, 191, 72, 0.3)' };
    case 'meesho':
      return { bg: 'rgba(244, 51, 151, 0.12)', text: '#c2185b', border: 'rgba(244, 51, 151, 0.25)' };
    case 'linkedin':
      return { bg: 'rgba(10, 102, 194, 0.12)', text: '#0a66c2', border: 'rgba(10, 102, 194, 0.25)' };
    default:
      return { bg: 'rgba(33, 150, 243, 0.12)', text: '#2196F3', border: 'rgba(33, 150, 243, 0.25)' };
  }
};

  const partitionSectionsForColumns = (sections, numCols) => {
    if (!sections || sections.length === 0) return [];
    if (numCols <= 1 || sections.length <= 1) return [sections];

    const cost = (s) => (s.items ? s.items.length : 0) + 3;
    const totalCost = sections.reduce((sum, s) => sum + cost(s), 0);
    const targetPerCol = totalCost / numCols;
    const cols = Array.from({ length: numCols }, () => []);
    const colWeights = Array.from({ length: numCols }, () => 0);

    let colIdx = 0;
    for (let i = 0; i < sections.length; i++) {
      const s = sections[i];
      const c = cost(s);
      const remainingSections = sections.length - i;
      const remainingCols = numCols - colIdx;

      if (remainingCols > 1 && remainingSections <= remainingCols) {
        if (cols[colIdx].length > 0) colIdx++;
      } else if (colIdx < numCols - 1) {
        const currentDiff = Math.abs(colWeights[colIdx] - targetPerCol);
        const withDiff = Math.abs(colWeights[colIdx] + c - targetPerCol);
        if (cols[colIdx].length > 0 && withDiff > currentDiff && colWeights[colIdx] >= targetPerCol * 0.7) {
          colIdx++;
        }
      }

      cols[colIdx].push(s);
      colWeights[colIdx] += c;
    }
    return cols.filter((col) => col.length > 0);
  };

  const renderVismeMegaMenu = ({ data, isTools = false, hideSidebar = false }) => {
    const targetCols = Math.min(
      isLg ? 4 : (isDesktop ? 3 : 2),
      Math.max(1, data.sections.length)
    );
    const balancedColumns = partitionSectionsForColumns(data.sections, targetCols);

    return (
      <Box
        className={classes.megaMenuWrapper}
        style={{ top: `${headerHeight}px` }}
        onMouseEnter={handleMenuEnter}
        onMouseLeave={() => {
          menuPointerInside.current = false;
          handleMenuLeave();
        }}
      >
        <Box className={classes.megaMenu}>
          {/* Close Menu Button */}
          <IconButton
            aria-label="Close menu"
            title="Close menu (Esc)"
            onClick={() => {
              menuPointerInside.current = false;
              setActiveMenu(null);
            }}
            size="small"
            sx={{
              position: 'absolute',
              top: 12,
              right: 14,
              zIndex: 1400,
              width: 32,
              height: 32,
              bgcolor: 'var(--surface-2)',
              color: 'var(--text-secondary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: 'var(--surface-3)',
                color: 'var(--text-primary)',
                transform: 'scale(1.08)',
              },
            }}
          >
            <FaTimes size={14} />
          </IconButton>
          
          {!hideSidebar && (
            <Box className={classes.megaSidebar}>
            {data.title === 'Services' ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                      <FaBolt color="#2563eb" size={12} />
                      <Typography sx={{ fontWeight: 800, color: 'var(--text-primary)', fontSize: '0.74rem', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                        Platform Updates
                      </Typography>
                    </Box>
                    <Box sx={{
                      fontSize: '0.58rem',
                      fontWeight: 700,
                      px: 0.7,
                      py: 0.15,
                      borderRadius: '4px',
                      backgroundColor: 'rgba(37, 99, 235, 0.12)',
                      color: '#2563eb',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Official Feed
                    </Box>
                  </Box>
                  <Typography sx={{ fontSize: '0.64rem', color: 'var(--text-secondary)', mb: 1.4, lineHeight: 1.3 }}>
                    What changed across search, ads, social & marketplaces
                  </Typography>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
                    {getLatestPlatformUpdates(3).map((update) => {
                      const badge = getPlatformBadgeColor(update.platformKey);
                      return (
                        <Box
                          key={update.id}
                          sx={{
                            p: '10px 11px',
                            borderRadius: '8px',
                            backgroundColor: 'var(--surface-1)',
                            border: '1px solid var(--border-color)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              borderColor: 'rgba(33, 150, 243, 0.45)',
                              backgroundColor: 'var(--surface-3)',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            }
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
                              <Box sx={{
                                width: 18,
                                height: 18,
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: badge.bg,
                                color: badge.text,
                              }}>
                                {renderPlatformIcon(update.platformKey)}
                              </Box>
                              <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, color: 'var(--text-primary)' }}>
                                {update.platform}
                              </Typography>
                            </Box>
                            <Typography sx={{ fontSize: '0.62rem', color: 'var(--text-secondary)', fontWeight: 500 }}>
                              {update.dateFormatted.split(',')[0]}
                            </Typography>
                          </Box>

                          <Typography sx={{
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            color: 'var(--text-primary)',
                            lineHeight: 1.25,
                            mb: 0.5,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                          }}>
                            {update.title}
                          </Typography>

                          <Typography sx={{
                            fontSize: '0.63rem',
                            color: 'var(--text-secondary)',
                            lineHeight: 1.35,
                            mb: 0.8,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                          }}>
                            {update.summary}
                          </Typography>

                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <a
                              href={update.sourceUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                fontSize: '0.64rem',
                                fontWeight: 600,
                                color: '#2563eb',
                                textDecoration: 'none',
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span>Read official update</span>
                              <span style={{ fontSize: '0.72rem', lineHeight: 1 }}>→</span>
                            </a>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>

                <Box sx={{ mt: 1.5, pt: 1.2, borderTop: '1px solid var(--border-color)', display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                  <Link
                    to="/resources/platform-updates/"
                    style={{ textDecoration: 'none' }}
                    onClick={() => setActiveMenu(null)}
                  >
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      py: 0.85,
                      px: 1.1,
                      borderRadius: '8px',
                      backgroundColor: 'var(--surface-3)',
                      color: '#2196F3',
                      fontWeight: 700,
                      fontSize: '0.72rem',
                      transition: 'all 0.2s ease',
                      border: '1px solid rgba(33, 150, 243, 0.25)',
                      '&:hover': {
                        backgroundColor: '#2196F3',
                        color: '#ffffff',
                      }
                    }}>
                      <span>View All Platform Updates</span>
                      <span>→</span>
                    </Box>
                  </Link>

                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 0.6 }}>
                    <Link
                      to="/resources/platform-updates/google/"
                      style={{ textDecoration: 'none' }}
                      onClick={() => setActiveMenu(null)}
                    >
                      <Box sx={{
                        textAlign: 'center',
                        py: 0.5,
                        px: 0.5,
                        borderRadius: '6px',
                        bgcolor: 'rgba(66, 133, 244, 0.08)',
                        color: '#1a73e8',
                        fontWeight: 700,
                        fontSize: '0.64rem',
                        border: '1px solid rgba(66, 133, 244, 0.2)',
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: '#1a73e8', color: '#ffffff' },
                      }}>
                        Google Search
                      </Box>
                    </Link>
                    <Link
                      to="/resources/platform-updates/google-ads/"
                      style={{ textDecoration: 'none' }}
                      onClick={() => setActiveMenu(null)}
                    >
                      <Box sx={{
                        textAlign: 'center',
                        py: 0.5,
                        px: 0.5,
                        borderRadius: '6px',
                        bgcolor: 'rgba(26, 115, 232, 0.08)',
                        color: '#1a73e8',
                        fontWeight: 700,
                        fontSize: '0.64rem',
                        border: '1px solid rgba(26, 115, 232, 0.25)',
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: '#1a73e8', color: '#ffffff' },
                      }}>
                        Google Ads
                      </Box>
                    </Link>
                    <Link
                      to="/resources/platform-updates/meta/"
                      style={{ textDecoration: 'none' }}
                      onClick={() => setActiveMenu(null)}
                    >
                      <Box sx={{
                        textAlign: 'center',
                        py: 0.5,
                        px: 0.5,
                        borderRadius: '6px',
                        bgcolor: 'rgba(0, 129, 251, 0.08)',
                        color: '#0081FB',
                        fontWeight: 700,
                        fontSize: '0.64rem',
                        border: '1px solid rgba(0, 129, 251, 0.2)',
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: '#0081FB', color: '#ffffff' },
                      }}>
                        Meta
                      </Box>
                    </Link>
                    <Link
                      to="/resources/platform-updates/amazon/"
                      style={{ textDecoration: 'none' }}
                      onClick={() => setActiveMenu(null)}
                    >
                      <Box sx={{
                        textAlign: 'center',
                        py: 0.5,
                        px: 0.5,
                        borderRadius: '6px',
                        bgcolor: 'rgba(234, 88, 12, 0.08)',
                        color: '#ea580c',
                        fontWeight: 700,
                        fontSize: '0.64rem',
                        border: '1px solid rgba(234, 88, 12, 0.2)',
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: '#ea580c', color: '#ffffff' },
                      }}>
                        Amazon
                      </Box>
                    </Link>
                    <Link
                      to="/resources/platform-updates/flipkart/"
                      style={{ textDecoration: 'none', gridColumn: 'span 2' }}
                      onClick={() => setActiveMenu(null)}
                    >
                      <Box sx={{
                        textAlign: 'center',
                        py: 0.5,
                        px: 0.5,
                        borderRadius: '6px',
                        bgcolor: 'rgba(40, 116, 240, 0.08)',
                        color: '#2874f0',
                        fontWeight: 700,
                        fontSize: '0.64rem',
                        border: '1px solid rgba(40, 116, 240, 0.2)',
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: '#2874f0', color: '#ffffff' },
                      }}>
                        Flipkart
                      </Box>
                    </Link>
                  </Box>

                  <Link
                    to="/services"
                    style={{ textDecoration: 'none' }}
                    onClick={() => setActiveMenu(null)}
                  >
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      py: 0.7,
                      px: 1.1,
                      borderRadius: '8px',
                      color: 'var(--text-secondary)',
                      fontWeight: 600,
                      fontSize: '0.68rem',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        color: 'var(--text-primary)',
                        backgroundColor: 'var(--surface-3)',
                      }
                    }}>
                      <span>Explore All Services</span>
                      <span>→</span>
                    </Box>
                  </Link>
                </Box>
              </Box>
            ) : (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <FaStar color="#f59e0b" style={{ marginRight: '8px' }} />
                  <Typography sx={{ fontWeight: 800, color: 'var(--text-primary)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                    {isTools ? "Most Used Tools" : "Highlights"}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  {(isTools ? frequentTools : (data.highlights || data.sections[0].items.slice(0, 5))).map((item, index) => (
                    <div key={index}>
                      <Link
                        to={item.path}
                        className={classes.featuredItem}
                        onClick={() => {
                          if(isTools) trackToolClick(item);
                          setActiveMenu(null);
                        }}
                      >
                         <Box className={classes.featuredIconBox} sx={{ backgroundColor: item.color + "1A", color: item.color }}>
                            <span style={{ fontSize: '1rem' }}>{getItemIcon(item, index)}</span>
                         </Box>
                        <Box sx={{ overflow: 'hidden' }}>
                          <Typography className={classes.featuredTitle}>{item.name}</Typography>
                          <Typography className={classes.featuredDesc}>{item.desc}</Typography>
                        </Box>
                      </Link>
                    </div>
                  ))}
                </Box>
                {isTools && (
                  <Box sx={{ mt: 1.5, pt: 1.2, borderTop: '1px solid var(--border-color)' }}>
                    <Link
                      to="/tools/"
                      style={{ textDecoration: 'none' }}
                      onClick={() => setActiveMenu(null)}
                    >
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        py: 0.85,
                        px: 1.1,
                        borderRadius: '8px',
                        backgroundColor: 'var(--surface-3)',
                        color: '#2196F3',
                        fontWeight: 700,
                        fontSize: '0.72rem',
                        transition: 'all 0.2s ease',
                        border: '1px solid rgba(33, 150, 243, 0.25)',
                        '&:hover': {
                          backgroundColor: '#2196F3',
                          color: '#ffffff',
                        }
                      }}>
                        <span>Explore All Free Tools</span>
                        <span>→</span>
                      </Box>
                    </Link>
                  </Box>
                )}
              </Box>
            )}
          </Box>
          )}

          <Box className={classes.megaBody}>
            {/* Guide Me & Visitor Purpose Banner */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 1.2,
              p: '7px 12px',
              mb: 1.8,
              borderRadius: '8px',
              background: data.title === 'Typography Lab' 
                ? 'linear-gradient(90deg, rgba(37,99,235,0.08) 0%, rgba(99,102,241,0.06) 100%)' 
                : 'linear-gradient(90deg, rgba(37,99,235,0.08) 0%, rgba(236,72,153,0.07) 100%)',
              border: '1px solid rgba(37,99,235,0.18)',
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span style={{ fontSize: '1.05rem' }}>{data.title === 'Typography Lab' ? '✒️' : '🧩'}</span>
                <Box>
                  <Typography sx={{ fontSize: '0.74rem', color: 'var(--text-primary)', fontWeight: 700, lineHeight: 1.2 }}>
                    {data.title === 'Typography Lab' 
                      ? 'Goafreet Typography Lab • Font Engineering, Layout Calculators & Custom Type Foundry' 
                      : 'Still puzzled what to do or what type of content to develop?'}
                  </Typography>
                  <Typography sx={{ fontSize: '0.64rem', color: 'var(--text-secondary)', lineHeight: 1.25 }}>
                    {data.title === 'Typography Lab'
                      ? 'Production-grade binary tools, vertical rhythm math engines, interactive letter studios, and enterprise foundry services.'
                      : 'Every tool and resource below is built for a specific goal. Not sure where to start? Let us guide you.'}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {data.title === 'Typography Lab' ? (
                  <Button
                    component={Link}
                    to="/typography/project-brief"
                    size="small"
                    onClick={() => setActiveMenu(null)}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 700,
                      fontSize: '0.7rem',
                      color: '#ffffff',
                      background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                      borderRadius: '6px',
                      px: 1.4,
                      py: 0.35,
                      boxShadow: '0 2px 6px rgba(37, 99, 235, 0.25)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)',
                      }
                    }}
                  >
                    Custom Project Brief Wizard →
                  </Button>
                ) : (
                  <Button
                    size="small"
                    onClick={() => {
                      setActiveMenu(null);
                      setGuideOpen(true);
                    }}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 700,
                      fontSize: '0.7rem',
                      color: '#2563eb',
                      backgroundColor: 'var(--surface-1)',
                      border: '1px solid rgba(37,99,235,0.3)',
                      borderRadius: '6px',
                      px: 1.4,
                      py: 0.35,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                      '&:hover': {
                        backgroundColor: '#2563eb',
                        color: '#ffffff',
                      }
                    }}
                  >
                    Guide Me Step-by-Step →
                  </Button>
                )}
              </Box>
            </Box>

            <Box sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: balancedColumns.length >= 2 ? 'repeat(2, minmax(0, 1fr))' : '1fr',
                md: balancedColumns.length >= 3 ? 'repeat(3, minmax(0, 1fr))' : `repeat(${balancedColumns.length}, minmax(0, 1fr))`,
                lg: `repeat(${balancedColumns.length}, minmax(0, 1fr))`,
              },
              gap: { xs: 1.5, md: 2, lg: 2.2 },
              width: '100%',
              alignItems: 'start',
            }}>
              {balancedColumns.map((colSections, colIdx) => (
                <Box
                  key={colIdx}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: 1.5, md: 2, lg: 2.2 },
                    minWidth: 0,
                  }}
                >
                  {colSections.map((section, idx) => (
                    <Box key={idx} className={classes.menuSection}>
                      <Box sx={{ mb: 0.8, pb: 0.4, borderBottom: '2px solid var(--border-color)' }}>
                        <Typography className={classes.sectionHeader}>{section.title}</Typography>
                        {section.subtitle && (
                          <Typography className={classes.sectionSubtitle}>
                            {section.subtitle}
                          </Typography>
                        )}
                      </Box>
                      <Box>
                        {section.items.map((item, i) => (
                          <Link
                            key={i}
                            to={item.path}
                            className={classes.standardListItem}
                            style={item.disabled ? { opacity: 0.45, pointerEvents: 'none', cursor: 'not-allowed' } : undefined}
                            onClick={() => {
                              if (isTools || activeMenu === 'marketplace' || activeMenu === 'typography') trackToolClick(item);
                              setActiveMenu(null);
                            }}
                          >
                            <Box
                              className={classes.standardItemIcon}
                              sx={{
                                backgroundColor: item.color ? `${item.color}15` : 'rgba(100, 116, 139, 0.1)',
                                color: item.color || '#64748b',
                              }}
                            >
                              {getItemIcon(item, i)}
                            </Box>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexWrap: 'nowrap' }}>
                                <span className={classes.standardItemTitle}>
                                  {item.name}
                                </span>
                                {item.badge && (
                                  <Box component="span" sx={{
                                    fontSize: '0.52rem',
                                    fontWeight: 800,
                                    px: 0.45,
                                    py: 0.1,
                                    borderRadius: '3px',
                                    backgroundColor: item.badge === 'NEW' || item.badge === 'HOT' ? 'rgba(236, 72, 153, 0.15)' : 'rgba(37, 99, 235, 0.15)',
                                    color: item.badge === 'NEW' || item.badge === 'HOT' ? '#ec4899' : '#2563eb',
                                    letterSpacing: '0.4px',
                                    textTransform: 'uppercase',
                                    lineHeight: 1,
                                    flexShrink: 0,
                                  }}>
                                    {item.badge}
                                  </Box>
                                )}
                              </Box>
                              {item.desc && (
                                <Typography className={classes.standardItemDesc}>
                                  {item.desc}
                                </Typography>
                              )}
                            </Box>
                          </Link>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>

            {/* Bottom breathing space cushion */}
            <Box sx={{ height: { xs: 48, md: 64 }, width: '100%', flexShrink: 0 }} aria-hidden="true" />
          </Box>

        </Box>
      </Box>
    );
  };

  const renderServicesMegaMenu = () => {
    const currentFamily = SERVICE_FAMILIES.find((f) => f.slug === selectedServiceFamilySlug) || SERVICE_FAMILIES[0];

    return (
      <Box
        className={classes.megaMenuWrapper}
        style={{ top: `${headerHeight}px` }}
        onMouseEnter={handleMenuEnter}
        onMouseLeave={() => {
          menuPointerInside.current = false;
          handleMenuLeave();
        }}
      >
        <Box className={classes.megaMenu} sx={{ minHeight: '520px', maxHeight: 'calc(100vh - 110px)' }}>
          {/* Close Menu Button */}
          <IconButton
            aria-label="Close menu"
            title="Close menu (Esc)"
            onClick={() => {
              menuPointerInside.current = false;
              setActiveMenu(null);
            }}
            size="small"
            sx={{
              position: 'absolute',
              top: 12,
              right: 14,
              zIndex: 1400,
              width: 32,
              height: 32,
              bgcolor: 'var(--surface-2)',
              color: 'var(--text-secondary)',
              border: '1px solid var(--border-color)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: 'var(--surface-3)',
                color: 'var(--text-primary)',
                transform: 'scale(1.08)',
              },
            }}
          >
            <FaTimes size={14} />
          </IconButton>

          {/* Left Rail: 10 Canonical Categories */}
          <Box
            role="tablist"
            aria-label="Service Areas"
            sx={{
              width: '280px',
              bgcolor: 'var(--surface-2)',
              borderRight: '1px solid var(--border-color)',
              p: 1.5,
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              flexShrink: 0,
              overflowY: 'auto',
            }}
          >
            <Box sx={{ px: 1, py: 0.75, mb: 0.5, borderBottom: '1px solid var(--border-color)' }}>
              <Typography sx={{ fontSize: '0.68rem', fontWeight: 800, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                Service Areas (10)
              </Typography>
            </Box>

            {SERVICE_FAMILIES.map((family, idx) => {
              const isSelected = family.slug === currentFamily.slug;
              return (
                <Box
                  key={family.slug}
                  component="button"
                  role="tab"
                  id={`service-tab-${family.slug}`}
                  aria-selected={isSelected}
                  aria-controls={`service-panel-${family.slug}`}
                  tabIndex={isSelected ? 0 : -1}
                  onClick={() => setSelectedServiceFamilySlug(family.slug)}
                  onMouseEnter={() => setSelectedServiceFamilySlug(family.slug)}
                  onKeyDown={(e) => {
                    if (e.key === 'ArrowDown') {
                      e.preventDefault();
                      const next = SERVICE_FAMILIES[(idx + 1) % SERVICE_FAMILIES.length];
                      setSelectedServiceFamilySlug(next.slug);
                      const el = document.getElementById(`service-tab-${next.slug}`);
                      if (el) el.focus();
                    } else if (e.key === 'ArrowUp') {
                      e.preventDefault();
                      const prev = SERVICE_FAMILIES[(idx - 1 + SERVICE_FAMILIES.length) % SERVICE_FAMILIES.length];
                      setSelectedServiceFamilySlug(prev.slug);
                      const el = document.getElementById(`service-tab-${prev.slug}`);
                      if (el) el.focus();
                    } else if (e.key === 'Escape') {
                      setActiveMenu(null);
                    }
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    px: 1.5,
                    py: 1.1,
                    borderRadius: '8px',
                    border: 'none',
                    textAlign: 'left',
                    cursor: 'pointer',
                    transition: 'all 0.15s ease',
                    bgcolor: isSelected ? 'var(--surface-3)' : 'transparent',
                    color: isSelected ? 'var(--text-primary)' : 'var(--text-secondary)',
                    fontWeight: isSelected ? 700 : 500,
                    borderLeft: isSelected ? `3px solid ${family.badgeColor || '#2563eb'}` : '3px solid transparent',
                    '&:hover': {
                      bgcolor: 'var(--surface-3)',
                      color: 'var(--text-primary)',
                    },
                    '&:focus': {
                      outline: 'none',
                      bgcolor: 'var(--surface-3)',
                      color: 'var(--text-primary)',
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                    <ServiceIcon slug={family.slug} size={17} color={isSelected ? (family.badgeColor || 'var(--text-primary)') : 'var(--text-secondary)'} />
                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 'inherit', color: 'inherit' }}>
                      {family.railLabel}
                    </Typography>
                  </Box>
                  <span style={{ fontSize: '0.72rem', opacity: isSelected ? 1 : 0.4 }}>→</span>
                </Box>
              );
            })}
          </Box>

          {/* Right Panel: Selected Category Showcase */}
          <Box
            id={`service-panel-${currentFamily.slug}`}
            role="tabpanel"
            aria-labelledby={`service-tab-${currentFamily.slug}`}
            sx={{
              flex: 1,
              p: { xs: 2, lg: 3.5 },
              pb: { xs: 5, lg: 7 },
              display: 'flex',
              flexDirection: 'column',
              maxHeight: 'calc(100vh - 120px)',
              overflowY: 'auto',
              bgcolor: 'var(--surface-1)',
            }}
          >
            {/* Category Header */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', pb: 2, mb: 2.5, borderBottom: '1px solid var(--border-color)', gap: 2 }}>
              <Box sx={{ maxWidth: '80%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 0.5 }}>
                  <ServiceIcon slug={currentFamily.slug} size={24} color={currentFamily.badgeColor || '#2563eb'} />
                  <Typography sx={{ fontWeight: 900, color: 'var(--text-primary)', fontSize: '1.2rem', letterSpacing: '-0.02em', textTransform: 'uppercase' }}>
                    {currentFamily.fullTitle}
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: '0.82rem', color: 'var(--text-secondary)', lineHeight: 1.55 }}>
                  {currentFamily.shortOverview}
                </Typography>
              </Box>

              <Link
                to={currentFamily.overviewRoute}
                style={{ textDecoration: 'none', flexShrink: 0 }}
                onClick={() => setActiveMenu(null)}
              >
                <Box sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  px: 1.8,
                  py: 0.85,
                  borderRadius: '8px',
                  bgcolor: 'rgba(37, 99, 235, 0.1)',
                  color: '#2563eb',
                  fontWeight: 700,
                  fontSize: '0.78rem',
                  border: '1px solid rgba(37, 99, 235, 0.25)',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    bgcolor: '#2563eb',
                    color: '#ffffff',
                  }
                }}>
                  <span>Explore Services</span>
                  <span>→</span>
                </Box>
              </Link>
            </Box>

            {/* 3-Column Services Grid */}
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: { md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
              gap: 1.5,
              mb: 3,
            }}>
              {currentFamily.capabilities.map((cap, i) => {
                if (cap.upcoming) {
                  return (
                    <Box
                      key={i}
                      sx={{
                        p: 1.5,
                        borderRadius: '8px',
                        border: '1px dashed var(--border-color)',
                        bgcolor: 'var(--surface-3)',
                        height: '100%',
                        opacity: 0.55,
                        cursor: 'not-allowed',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.4 }}>
                          <Typography sx={{ fontWeight: 700, fontSize: '0.84rem', color: 'var(--text-secondary)', lineHeight: 1.3 }}>
                            {cap.label}
                          </Typography>
                          <Box component="span" sx={{
                            fontSize: '0.58rem',
                            fontWeight: 700,
                            px: 0.6,
                            py: 0.15,
                            borderRadius: '4px',
                            bgcolor: 'rgba(100, 116, 139, 0.15)',
                            color: 'var(--text-secondary)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                          }}>
                            Upcoming
                          </Box>
                        </Box>
                        <Typography sx={{ fontSize: '0.73rem', color: 'var(--text-secondary)', lineHeight: 1.45 }}>
                          {cap.description}
                        </Typography>
                      </Box>
                      <Box sx={{ pt: 1, display: 'flex', alignItems: 'center', color: 'var(--text-secondary)', fontSize: '0.72rem', fontWeight: 600, opacity: 0.8 }}>
                        <span>Upcoming Service</span>
                      </Box>
                    </Box>
                  );
                }

                return (
                  <Link
                    key={i}
                    to={cap.route}
                    style={{ textDecoration: 'none' }}
                    onClick={() => setActiveMenu(null)}
                  >
                    <Box sx={{
                      p: 1.5,
                      borderRadius: '8px',
                      border: '1px solid var(--border-color)',
                      bgcolor: 'var(--surface-2)',
                      height: '100%',
                      transition: 'all 0.18s ease',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      '&:hover': {
                        bgcolor: 'var(--surface-3)',
                        borderColor: '#2563eb',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 16px rgba(0,0,0,0.06)',
                      }
                    }}>
                      <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.4 }}>
                          <Typography sx={{ fontWeight: 700, fontSize: '0.84rem', color: 'var(--text-primary)', lineHeight: 1.3 }}>
                            {cap.label}
                          </Typography>
                        </Box>
                        <Typography sx={{ fontSize: '0.73rem', color: 'var(--text-secondary)', lineHeight: 1.45 }}>
                          {cap.description}
                        </Typography>
                      </Box>
                      <Box sx={{ pt: 1, display: 'flex', alignItems: 'center', gap: 0.5, color: '#2563eb', fontSize: '0.72rem', fontWeight: 700 }}>
                        <span>View service details</span>
                        <span>→</span>
                      </Box>
                    </Box>
                  </Link>
                );
              })}
            </Box>

            {/* Bottom Action Footer */}
            <Box sx={{
              mt: 'auto',
              pt: 2,
              borderTop: '1px solid var(--border-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 1.5,
            }}>
              <Link
                to={currentFamily.overviewRoute}
                style={{ textDecoration: 'none' }}
                onClick={() => setActiveMenu(null)}
              >
                <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: 'var(--text-secondary)', '&:hover': { color: '#2563eb' } }}>
                  Explore Services in {currentFamily.railLabel} →
                </Typography>
              </Link>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.8 }}>
                <Link
                  to="/services/"
                  style={{ textDecoration: 'none' }}
                  onClick={() => setActiveMenu(null)}
                >
                  <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.6,
                    fontSize: '0.8rem',
                    fontWeight: 700,
                    color: '#2563eb',
                    '&:hover': { textDecoration: 'underline' }
                  }}>
                    <span>View All Services</span>
                    <span>→</span>
                  </Box>
                </Link>

                <Link
                  to="/services/"
                  style={{ textDecoration: 'none' }}
                  onClick={() => setActiveMenu(null)}
                >
                  <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    px: 1.2,
                    py: 0.45,
                    borderRadius: '6px',
                    border: '1px solid var(--border-color)',
                    bgcolor: 'var(--surface-2)',
                    fontSize: '0.74rem',
                    fontWeight: 700,
                    color: 'var(--text-primary)',
                    transition: 'all 0.15s ease',
                    '&:hover': {
                      bgcolor: 'var(--surface-3)',
                      borderColor: '#2563eb',
                      color: '#2563eb',
                    }
                  }}>
                    Service Portfolio
                  </Box>
                </Link>
              </Box>
            </Box>

            {/* Bottom breathing space cushion */}
            <Box sx={{ height: { xs: 48, md: 60 }, width: '100%', flexShrink: 0 }} aria-hidden="true" />
          </Box>
        </Box>
      </Box>
    );
  };

  const renderMobileSection = (key, title, icon, dataObj) => {
    return (
      <Fragment key={key}>
        <ListItemButton onClick={() => handleMobileExpand(key)} sx={{ py: 1.5, borderBottom: '1px solid var(--border-color)' }}>
          <ListItemIcon sx={{ minWidth: 36, color: '#1565c0' }}>{icon}</ListItemIcon>
          <ListItemText primary={<Typography fontWeight={700} fontSize="0.9rem" sx={{ color: 'text.primary' }}>{title}</Typography>} />
          {mobileExpanded[key] ? <FaChevronUp size={12} style={{ color: "var(--text-secondary)" }} /> : <FaChevronDown size={12} style={{ color: "var(--text-secondary)" }} />}
        </ListItemButton>
        
        <Collapse in={mobileExpanded[key]} unmountOnExit>
          <Box sx={{ pl: 3.5, pr: 1.5, py: 1.5, bgcolor: 'var(--surface-2)' }}>
            {key === 'services' ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box sx={{ mb: 1.2 }}>
                  <Link
                    to="/services/"
                    style={{
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(37, 99, 235, 0.1)',
                      color: '#2563eb',
                      fontWeight: 700,
                      fontSize: '0.78rem',
                      border: '1px solid rgba(37, 99, 235, 0.25)',
                    }}
                    onClick={handleDrawerToggle}
                  >
                    <span>View All Services</span>
                    <span>→</span>
                  </Link>
                </Box>

                {SERVICE_FAMILIES.map((fam) => {
                  const isFamExpanded = !!mobileExpandedServiceFamily[fam.slug];
                  return (
                    <Box key={fam.slug} sx={{ borderBottom: '1px solid var(--border-color)', pb: 0.5 }}>
                      <Box
                        onClick={() => toggleMobileServiceFamily(fam.slug)}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          py: 1,
                          cursor: 'pointer',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <ServiceIcon slug={fam.slug} size={18} color={fam.badgeColor || 'primary.main'} />
                          <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: 'text.primary' }}>
                            {fam.railLabel}
                          </Typography>
                        </Box>
                        {isFamExpanded ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                      </Box>

                      <Collapse in={isFamExpanded} unmountOnExit>
                        <Box sx={{ pl: 3.2, pr: 0.5, py: 1 }}>
                          <Typography sx={{ fontSize: '0.72rem', color: 'text.secondary', mb: 1.2, lineHeight: 1.4 }}>
                            {fam.shortOverview}
                          </Typography>
                          <Stack spacing={0.8} sx={{ mb: 1.5 }}>
                            {fam.capabilities.map((cap, cIdx) => (
                              cap.upcoming ? (
                                <Box key={cIdx} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', opacity: 0.55, cursor: 'not-allowed', py: 0.2 }}>
                                  <Typography sx={{ fontSize: '0.76rem', color: 'text.secondary', fontWeight: 500 }}>
                                    • {cap.label}
                                  </Typography>
                                  <Typography sx={{ fontSize: '0.62rem', color: 'text.secondary', fontStyle: 'italic' }}>
                                    Upcoming
                                  </Typography>
                                </Box>
                              ) : (
                                <Link
                                  key={cIdx}
                                  to={cap.route}
                                  style={{ textDecoration: 'none' }}
                                  onClick={handleDrawerToggle}
                                >
                                  <Typography sx={{ fontSize: '0.76rem', color: 'text.primary', fontWeight: 600, '&:hover': { color: '#2563eb' } }}>
                                    • {cap.label}
                                  </Typography>
                                </Link>
                              )
                            ))}
                          </Stack>
                          <Link
                            to={fam.overviewRoute}
                            style={{ textDecoration: 'none', color: '#2563eb', fontSize: '0.74rem', fontWeight: 700, display: 'inline-block' }}
                            onClick={handleDrawerToggle}
                          >
                            Explore {fam.railLabel} Services →
                          </Link>
                        </Box>
                      </Collapse>
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <Fragment>
                {key === 'tools' && (
                  <Box sx={{ mb: 2 }}>
                    <Link
                      to="/tools/"
                      style={{
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        backgroundColor: 'rgba(37, 99, 235, 0.1)',
                        color: '#2563eb',
                        fontWeight: 700,
                        fontSize: '0.78rem',
                        border: '1px solid rgba(37, 99, 235, 0.25)',
                      }}
                      onClick={handleDrawerToggle}
                    >
                      <span>Explore All Tools & Utilities</span>
                      <span>→</span>
                    </Link>
                  </Box>
                )}
                {dataObj.sections.map((section, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: idx * 0.05 }}
                  >
                  <Box sx={{ mb: 2 }}>
                    <Typography sx={{ fontSize: '0.68rem', fontWeight: 800, color: 'text.primary', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                      {section.title}
                    </Typography>
                    {section.subtitle && (
                      <Typography sx={{ fontSize: '0.64rem', color: 'text.secondary', mb: 0.8, lineHeight: 1.3 }}>
                        {section.subtitle}
                      </Typography>
                    )}
                    <Grid container spacing={1}>
                      {section.items.map((item, i) => (
                        <Grid item xs={12} sm={6} key={i}>
                          <Link 
                            to={item.path} 
                            style={{ textDecoration: 'none', display: 'flex', alignItems: 'flex-start', padding: '6px 0', ...(item.disabled ? { opacity: 0.45, pointerEvents: 'none', cursor: 'not-allowed' } : {}) }}
                            onClick={() => {
                              if (key === 'tools' || key === 'marketplace') trackToolClick(item);
                              handleDrawerToggle();
                            }}
                          >
                            <Box sx={{
                              width: 24,
                              height: 24,
                              borderRadius: '5px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: item.color ? `${item.color}15` : 'rgba(100, 116, 139, 0.1)',
                              color: item.color || '#64748b',
                              fontSize: '0.8rem',
                              mr: 1,
                              mt: 0.1,
                              flexShrink: 0
                            }}>
                              {getItemIcon(item, i)}
                            </Box>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, flexWrap: 'wrap' }}>
                                <Typography sx={{ fontSize: '0.76rem', fontWeight: 700, color: 'text.primary', lineHeight: 1.25 }}>
                                  {item.name}
                                </Typography>
                                {item.badge && (
                                  <Box component="span" sx={{
                                    fontSize: '0.52rem',
                                    fontWeight: 800,
                                    px: 0.5,
                                    py: 0.1,
                                    borderRadius: '3px',
                                    backgroundColor: item.badge === 'NEW' || item.badge === 'HOT' ? 'rgba(236, 72, 153, 0.15)' : 'rgba(37, 99, 235, 0.15)',
                                    color: item.badge === 'NEW' || item.badge === 'HOT' ? '#ec4899' : '#2563eb',
                                    lineHeight: 1,
                                  }}>
                                    {item.badge}
                                  </Box>
                                )}
                              </Box>
                              {item.desc && (
                                <Typography sx={{ fontSize: '0.65rem', color: 'text.secondary', lineHeight: 1.3, mt: 0.2 }}>
                                  {item.desc}
                                </Typography>
                              )}
                            </Box>
                          </Link>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </motion.div>
              ))}
              </Fragment>
            )}
          </Box>
        </Collapse>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <AppBar position="sticky" ref={appBarRef} className={classes.appBar} elevation={0} sx={{ top: 0 }}>
        {/* ROW 1: BRAND LOGO & GLOBAL ACTIONS (Clock, Search, Guide, Theme, Start Project) */}
        <Box
          className={classes.topBar}
          sx={{
            width: "100%",
            maxWidth: "1600px",
            margin: "0 auto",
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 0.6, sm: 0.8 },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 1, md: 2 },
          }}
        >
          {/* Brand Logo */}
          <Box className={classes.headerBrand} sx={{ pl: { xs: 0.5, sm: 1 } }}>
            <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
              <img src={bricon} alt="Goafreet" className={classes.logo} />
            </Link>
          </Box>

          {/* Row 1 Right: Live Weather Clock, Search, Guide, Theme, Start Project CTA */}
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.8, sm: 1.25 }, ml: "auto" }}>
            {/* Real-time Weather & Digital Clock Widget (Desktop only) */}
            <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
              <WeatherClockWidget variant="header" />
            </Box>

            {/* Guide Me Button */}
            <Tooltip title="Guide Me">
              <motion.div whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}>
                <IconButton
                  aria-label="open guide"
                  onClick={() => setGuideOpen(true)}
                  size="small"
                  sx={{
                    color: "#38bdf8",
                    width: { xs: 34, sm: 38 },
                    height: { xs: 34, sm: 38 },
                    borderRadius: "8px",
                    bgcolor: "var(--surface-2)",
                    border: "1px solid var(--border-color)",
                    "&:hover": { bgcolor: "var(--surface-3)" },
                  }}
                >
                  <FaCompass size={15} />
                </IconButton>
              </motion.div>
            </Tooltip>

            {/* Global 3D Search (Ctrl+K) */}
            <Tooltip title="Global 3D Search (Ctrl+K)">
              <motion.div whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.94 }}>
                <Button
                  onClick={openSearchOverlay}
                  size="small"
                  startIcon={<FaSearch size={13} style={{ color: "var(--text-secondary)" }} />}
                  sx={{
                    display: { xs: "none", sm: "inline-flex" },
                    textTransform: "none",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    bgcolor: "var(--surface-2)",
                    border: "1px solid var(--border-color)",
                    borderRadius: "8px",
                    px: 1.5,
                    py: 0.5,
                    height: 38,
                    "&:hover": {
                      bgcolor: "var(--surface-3)",
                      color: "var(--text-primary)",
                      borderColor: "rgba(37,99,235,0.4)",
                    },
                  }}
                >
                  <span>Search tools & pages...</span>
                  <Box
                    component="span"
                    sx={{
                      ml: 1.5,
                      px: 0.7,
                      py: 0.15,
                      fontSize: "0.68rem",
                      fontWeight: 700,
                      borderRadius: "4px",
                      bgcolor: "var(--surface-1)",
                      border: "1px solid var(--border-color)",
                      color: "var(--text-secondary)",
                    }}
                  >
                    Ctrl+K
                  </Box>
                </Button>
              </motion.div>
            </Tooltip>

            {/* Mobile Search Icon button */}
            <Box sx={{ display: { xs: "inline-flex", sm: "none" } }}>
              <IconButton
                aria-label="open search"
                onClick={openSearchOverlay}
                size="small"
                sx={{
                  color: "text.primary",
                  width: 34,
                  height: 34,
                  borderRadius: "8px",
                  bgcolor: "var(--surface-2)",
                  border: "1px solid var(--border-color)",
                  "&:hover": { bgcolor: "var(--surface-3)" },
                }}
              >
                <FaSearch size={13} />
              </IconButton>
            </Box>

            {/* Theme Toggle */}
            <motion.div whileHover={{ scale: 1.06, rotate: 15 }} whileTap={{ scale: 0.94 }}>
              <ThemeToggle />
            </motion.div>

            {/* Start Project CTA Button */}
            <Box sx={{ display: { xs: "none", lg: "inline-flex" } }}>
              <Button
                component={Link}
                to="/typography/project-brief"
                variant="contained"
                size="small"
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  letterSpacing: "0.02em",
                  background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                  color: "#ffffff",
                  borderRadius: "8px",
                  px: 1.8,
                  py: 0.7,
                  boxShadow: "0 2px 8px rgba(37, 99, 235, 0.25)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)",
                    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.35)",
                  },
                }}
              >
                Start a Project →
              </Button>
            </Box>

            {/* Mobile Drawer Hamburger */}
            <Box sx={{ display: { xs: "inline-flex", md: "none" } }}>
              <IconButton
                aria-label="open menu"
                onClick={handleDrawerToggle}
                sx={{
                  color: "text.primary",
                  width: { xs: 34, sm: 38 },
                  height: { xs: 34, sm: 38 },
                  borderRadius: "8px",
                  bgcolor: "var(--surface-2)",
                  border: "1px solid var(--border-color)",
                  "&:hover": { bgcolor: "var(--surface-3)" },
                }}
              >
                <FaBars size={16} />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* ROW 2: DEDICATED FULL-WIDTH NAVIGATION MENU BAR */}
        <Box
          className={classes.navRail}
          sx={{
            width: "100%",
            borderTop: "1px solid var(--border-color)",
            backgroundColor: "var(--surface-2)",
          }}
        >
          <Box
            sx={{
              maxWidth: "1600px",
              margin: "0 auto",
              px: { xs: 2, sm: 3, md: 4 },
              py: { xs: 0.35, md: 0.45 },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            {/* Desktop Navigation Items: Spacious, Un-squeezed, Generous padding */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: { md: 0.3, lg: 0.65 },
                pl: { xs: 0.5, sm: 1 },
                flexWrap: "nowrap",
                minWidth: 0,
                overflowX: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              <Button
                component={Link}
                to="/"
                className={classes.navButton}
              >
                Home
              </Button>

              <Button
                className={`${classes.dropdownButton} ${activeMenu === 'tools' ? "header-dropdown-active" : ""}`}
                onMouseEnter={() => isDesktop && handleMenuHover("tools")}
                onMouseLeave={() => isDesktop && handleMenuLeave()}
                onClick={() => isDesktop ? handleMenuToggle("tools") : handleMobileCategoryClick("tools")}
                endIcon={<FaChevronDown size={10} style={{ transform: activeMenu === 'tools' ? 'rotate(180deg)' : 'none', transition: '0.2s' }}/>}
              >
                Tools
              </Button>

              <Button
                className={`${classes.dropdownButton} ${activeMenu === 'typography' ? "header-dropdown-active" : ""}`}
                onMouseEnter={() => isDesktop && handleMenuHover("typography")}
                onMouseLeave={() => isDesktop && handleMenuLeave()}
                onClick={() => isDesktop ? handleMenuToggle("typography") : handleMobileCategoryClick("typography")}
                endIcon={<FaChevronDown size={10} style={{ transform: activeMenu === 'typography' ? 'rotate(180deg)' : 'none', transition: '0.2s' }}/>}
              >
                <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                  <FaFont size={11} style={{ color: "#2563eb" }} />
                  <span>Typography Lab</span>
                  <Box
                    component="span"
                    sx={{
                      fontSize: "0.58rem",
                      fontWeight: 800,
                      px: 0.5,
                      py: 0.1,
                      borderRadius: "3px",
                      bgcolor: "rgba(37, 99, 235, 0.12)",
                      color: "#2563eb",
                      lineHeight: 1,
                    }}
                  >
                    NEW
                  </Box>
                </Box>
              </Button>

              <Button
                className={`${classes.dropdownButton} ${activeMenu === 'marketplace' ? "header-dropdown-active" : ""}`}
                onMouseEnter={() => isDesktop && handleMenuHover("marketplace")}
                onMouseLeave={() => isDesktop && handleMenuLeave()}
                onClick={() => isDesktop ? handleMenuToggle("marketplace") : handleMobileCategoryClick("marketplace")}
                endIcon={<FaChevronDown size={10} style={{ transform: activeMenu === 'marketplace' ? 'rotate(180deg)' : 'none', transition: '0.2s' }}/>}
              >
                E-Commerce
              </Button>

              <Button
                className={`${classes.dropdownButton} ${activeMenu === 'services' ? "header-dropdown-active" : ""}`}
                onMouseEnter={() => isDesktop && handleMenuHover("services")}
                onMouseLeave={() => isDesktop && handleMenuLeave()}
                onClick={() => isDesktop ? handleMenuToggle("services") : handleMobileCategoryClick("services")}
                endIcon={<FaChevronDown size={10} style={{ transform: activeMenu === 'services' ? 'rotate(180deg)' : 'none', transition: '0.2s' }}/>}
              >
                Services
              </Button>

              <Button
                component={Link}
                to="/portfolio"
                className={classes.navButton}
              >
                Portfolio
              </Button>

              <Button
                className={`${classes.dropdownButton} ${activeMenu === 'resources' ? "header-dropdown-active" : ""}`}
                onMouseEnter={() => isDesktop && handleMenuHover("resources")}
                onMouseLeave={() => isDesktop && handleMenuLeave()}
                onClick={() => isDesktop ? handleMenuToggle("resources") : handleMobileCategoryClick("resources")}
                endIcon={<FaChevronDown size={10} style={{ transform: activeMenu === 'resources' ? 'rotate(180deg)' : 'none', transition: '0.2s' }}/>}
              >
                Resources
              </Button>

              <Button
                component={Link}
                to="/innovation"
                className={classes.navButton}
              >
                Innovation
              </Button>

              <Button
                component={Link}
                to="/technology-news"
                className={classes.navButton}
              >
                Tech News
              </Button>

              <Button
                component={Link}
                to="/contact-support"
                className={classes.navButton}
              >
                Support
              </Button>
            </Box>

            {/* On mobile: Quick category touch pills */}
            <Box sx={{ display: { xs: "flex", md: "none" }, gap: 0.6, alignItems: "center", overflowX: "auto", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
              <Button
                component={Link}
                to="/"
                size="small"
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "none",
                  py: 0.2,
                  px: 0.9,
                  borderRadius: "6px",
                  color: "var(--text-secondary)",
                  bgcolor: "var(--surface-1)",
                  border: "1px solid var(--border-color)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Home
              </Button>
              <Button
                onClick={() => handleMobileCategoryClick("tools")}
                size="small"
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "none",
                  py: 0.2,
                  px: 0.9,
                  borderRadius: "6px",
                  color: "var(--text-secondary)",
                  bgcolor: "var(--surface-1)",
                  border: "1px solid var(--border-color)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Tools
              </Button>
              <Button
                onClick={() => handleMobileCategoryClick("typography")}
                size="small"
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "none",
                  py: 0.2,
                  px: 0.9,
                  borderRadius: "6px",
                  color: "#2563eb",
                  bgcolor: "rgba(37, 99, 235, 0.08)",
                  border: "1px solid rgba(37, 99, 235, 0.25)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Typography
              </Button>
              <Button
                onClick={() => handleMobileCategoryClick("marketplace")}
                size="small"
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "none",
                  py: 0.2,
                  px: 0.9,
                  borderRadius: "6px",
                  color: "var(--text-secondary)",
                  bgcolor: "var(--surface-1)",
                  border: "1px solid var(--border-color)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                E-Commerce
              </Button>
              <Button
                onClick={() => handleMobileCategoryClick("services")}
                size="small"
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "none",
                  py: 0.2,
                  px: 0.9,
                  borderRadius: "6px",
                  color: "var(--text-secondary)",
                  bgcolor: "var(--surface-1)",
                  border: "1px solid var(--border-color)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                Services
              </Button>
              <Button
                component={Link}
                to="/technology-news/"
                size="small"
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  textTransform: "none",
                  py: 0.2,
                  px: 0.9,
                  borderRadius: "6px",
                  color: "#2563eb",
                  bgcolor: "rgba(37, 99, 235, 0.08)",
                  border: "1px solid rgba(37, 99, 235, 0.25)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <FaNewspaper size={11} /> Tech News
              </Button>
            </Box>

            {/* Right side: Desktop Live Verified Technology News Stream */}
            <Box sx={{ display: { xs: "none", xl: "flex" }, alignItems: "center", gap: 1.25, minWidth: 0, flexShrink: 0, ml: "auto" }}>
              <Link
                to="/technology-news/"
                style={{ textDecoration: "none" }}
                title="Explore official technology announcements and verified engineering feeds"
              >
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.55,
                    fontSize: "0.72rem",
                    fontWeight: 750,
                    color: "#2563eb",
                    px: 0.85,
                    py: 0.2,
                    borderRadius: "9999px",
                    bgcolor: "rgba(37, 99, 235, 0.08)",
                    border: "1px solid rgba(37, 99, 235, 0.22)",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    "&:hover": {
                      bgcolor: "#2563eb",
                      color: "#ffffff",
                      borderColor: "#2563eb",
                    },
                  }}
                >
                  <FaNewspaper size={11} />
                  <span>News Stream</span>
                </Box>
              </Link>

              <Divider orientation="vertical" flexItem sx={{ height: 14, my: "auto" }} />

              <Link
                to="/technology-news/"
                style={{ textDecoration: "none", minWidth: 0 }}
                title="Click to view full verified tech announcement"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                    maxWidth: 320,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    transition: "opacity 0.2s",
                    "&:hover": { opacity: 0.85 },
                  }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: 24,
                      height: 20,
                      bgcolor: "var(--surface-1)",
                      border: "1px solid var(--border-color)",
                      px: 0.5,
                      py: 0.1,
                      borderRadius: "4px",
                      flexShrink: 0,
                    }}
                  >
                    {renderPublisherLogo(techHeadlines[techHeadlineIdx].publisher, 13)}
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "0.72rem",
                      fontWeight: 600,
                      color: "var(--text-primary)",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      "&:hover": { color: "#2563eb" },
                    }}
                  >
                    {techHeadlines[techHeadlineIdx].title}
                  </Typography>

                  <Box sx={{ fontSize: "0.7rem", color: "var(--text-secondary)", flexShrink: 0 }}>
                    ↗
                  </Box>
                </Box>
              </Link>
            </Box>
          </Box>
        </Box>
      </AppBar>

      {/* Backdrop overlay for mega menus */}
      {activeMenu && isDesktop && (
        <Box
          onClick={() => {
            menuPointerInside.current = false;
            setActiveMenu(null);
          }}
          sx={{
            position: 'fixed',
            top: `${headerHeight}px`,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1200,
            bgcolor: 'rgba(0, 0, 0, 0.35)',
            backdropFilter: 'blur(3px)',
            cursor: 'pointer',
          }}
        />
      )}

      {activeMenu === 'tools' && isDesktop && renderVismeMegaMenu({ data: toolsMenuData, isTools: true })}
      {activeMenu === 'typography' && isDesktop && renderVismeMegaMenu({ data: typographyMenuData, isTools: false, hideSidebar: true })}
      {activeMenu === 'marketplace' && isDesktop && renderVismeMegaMenu({ data: marketplaceMenuData, isTools: true })}
      {activeMenu === 'services' && isDesktop && renderServicesMegaMenu()}
      {activeMenu === 'resources' && isDesktop && renderVismeMegaMenu({ data: resourcesMenu })}

      <AnimatePresence>
        {searchOverlayOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                zIndex: 1500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(4, 8, 20, 0.78)',
                backdropFilter: 'blur(16px)',
                overflow: 'hidden',
              }}
            >
              <IconButton 
                onClick={closeSearchOverlay} 
                aria-label="Close search"
                sx={{ 
                  position: 'fixed',
                  top: { xs: 16, sm: 28 },
                  right: { xs: 16, sm: 32 },
                  zIndex: 2100,
                  color: '#fff',
                  bgcolor: 'rgba(255, 255, 255, 0.08)',
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.22)',
                    transform: 'rotate(90deg)',
                  },
                  transition: 'all 0.3s ease',
                  width: 44,
                  height: 44,
                }}
              >
                <FaTimes size={18} />
              </IconButton>

              <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                }}
              >
                <SearchBar variant="gradient" siteIndex={siteIndex} onClose={closeSearchOverlay} />
              </Box>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>

      {/* MOBILE DRAWER */}
      <AnimatePresence>
        {mobileOpen && (
          <Drawer
            variant="temporary"
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            PaperProps={{ className: classes.mobileDrawer, sx: { height: "100dvh", display: "flex", flexDirection: "column" } }}
          >
            <Box sx={{ padding: "1rem 1.25rem", borderBottom: '1px solid var(--border-color)', display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Link to="/" onClick={handleDrawerToggle} style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                <img src={bricon} alt="Goafreet" style={{ height: 32, maxWidth: 160, objectFit: "contain", borderRadius: 6 }} />
              </Link>
              <IconButton onClick={handleDrawerToggle} sx={{ color: "text.secondary", p: 1 }} aria-label="Close menu">
                <FaTimes />
              </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", py: 1.5 }}>
              <Box sx={{ px: 2, pb: 1.5, display: "flex", justifyContent: "center" }}>
                <WeatherClockWidget variant="header" />
              </Box>
              <List>
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ListItemButton component={Link} to="/" onClick={handleDrawerToggle} sx={{ py: 1.5, borderBottom: '1px solid var(--border-color)' }}>
                    <ListItemIcon sx={{ minWidth: 36, color: '#1565c0' }}><FaHome /></ListItemIcon>
                    <ListItemText primary={<Typography fontWeight={700} fontSize="0.9rem" sx={{ color: 'text.primary' }}>Home</Typography>} />
                  </ListItemButton>

                  {renderMobileSection("tools", "Tools", <FaTools />, toolsMenuData)}
                  {renderMobileSection("typography", "Typography & Fonts", <FaFont />, typographyMenuData)}
                  {renderMobileSection("marketplace", "E-Commerce", <FaStore />, marketplaceMenuData)}
                  {renderMobileSection("services", "Services", <FaBriefcase />, servicesMenu)}
                  {renderMobileSection("resources", "Resources", <FaBook />, resourcesMenu)}

                  <ListItemButton component={Link} to="/innovation" onClick={handleDrawerToggle} sx={{ py: 1.5, borderBottom: '1px solid var(--border-color)' }}>
                    <ListItemIcon sx={{ minWidth: 36, color: '#10b981' }}><FaGlobeAmericas /></ListItemIcon>
                    <ListItemText primary={<Typography fontWeight={700} fontSize="0.9rem" sx={{ color: 'text.primary' }}>Innovation Explorer</Typography>} />
                  </ListItemButton>

                  <ListItemButton component={Link} to="/technology-news" onClick={handleDrawerToggle} sx={{ py: 1.5, borderBottom: '1px solid var(--border-color)' }}>
                    <ListItemIcon sx={{ minWidth: 36, color: '#2563eb' }}><FaNewspaper /></ListItemIcon>
                    <ListItemText primary={<Typography fontWeight={700} fontSize="0.9rem" sx={{ color: 'text.primary' }}>Technology News</Typography>} />
                  </ListItemButton>

                  <ListItemButton component={Link} to="/portfolio" onClick={handleDrawerToggle} sx={{ py: 1.5, borderBottom: '1px solid var(--border-color)' }}>
                    <ListItemIcon sx={{ minWidth: 36, color: '#1565c0' }}><FaTrophy /></ListItemIcon>
                    <ListItemText primary={<Typography fontWeight={700} fontSize="0.9rem" sx={{ color: 'text.primary' }}>Portfolio</Typography>} />
                  </ListItemButton>

                  <ListItemButton component={Link} to="/contact-support" onClick={handleDrawerToggle} sx={{ py: 1.5, borderBottom: '1px solid var(--border-color)' }}>
                    <ListItemIcon sx={{ minWidth: 36, color: '#1565c0' }}><FaPhoneAlt /></ListItemIcon>
                    <ListItemText primary={<Typography fontWeight={700} fontSize="0.9rem" sx={{ color: 'text.primary' }}>Support</Typography>} />
                  </ListItemButton>
                </motion.div>
              </List>
            </Box>

            <Box sx={{ padding: "1rem", backgroundColor: "var(--surface-2)", borderTop: "1px solid var(--border-color)", textAlign: "center" }}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 }}
              >
                <Typography variant="body2" sx={{ color: "text.secondary", marginBottom: "0.5rem", fontSize: '0.75rem', fontWeight: 600 }}>Follow us</Typography>
                <Box display="flex" justifyContent="center" gap={1.5}>
                  <IconButton href="https://www.instagram.com/go_afreet/" target="_blank" size="small" sx={{ color: "#E4405F" }}><FaInstagram size={16}/></IconButton>
                  <IconButton href="https://www.facebook.com/goafreet-102140594767868/" target="_blank" size="small" sx={{ color: "#1877F2" }}><FaFacebook size={16} /></IconButton>
                  <IconButton href="https://twitter.com/@AfreetGo" target="_blank" size="small" sx={{ color: "#1DA1F2" }}><FaTwitter size={16} /></IconButton>
                  <IconButton href="https://www.linkedin.com/company/go-afreet" target="_blank" size="small" sx={{ color: "#0A66C2" }}><FaLinkedin size={16} /></IconButton>
                  <IconButton href="https://www.youtube.com/channel/UCVkmUg-aVFwSmFkJcsQUsIw/videos" target="_blank" size="small" sx={{ color: "#FF0000" }}><FaYoutube size={16} /></IconButton>
                  <IconButton href="https://wa.me/+919106981512" target="_blank" size="small" sx={{ color: "#25D366" }}><FaWhatsapp size={16} /></IconButton>
                </Box>
              </motion.div>
            </Box>
          </Drawer>
        )}
      </AnimatePresence>

      {/* SMART GUIDE UI */}
      <SmartGuidePanel open={guideOpen} onClose={() => setGuideOpen(false)} />
    </Fragment>
  );
}

export default Header;
